import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { get3wViewerLink, isAdvancedExchangeServiceType, getLangCode } from "../common/utils.js";

import { ShipmentListWidget } from "../common/shipmentListWidget.jsx";
import { Services } from './iServices.jsx';
import { sanitizeUrl } from "../common/utils.js";

import 'regenerator-runtime/runtime';
import 'react-toastify/dist/ReactToastify.css';

import '../assets/css/q2cui_oss.css';
import '../assets/css/oswidget.css';
import './widget-style.css';
import '../vendors/fa.js';
import '../vendors/fas.js';
import '../vendors/fac.js';

import '../assets/css/uppexternal.css';

import Bill_RGB_gray_NT from '../assets/images/Bill_RGB_gray_NT.png';
import Factory_RGB_gray_NT2 from '../assets/images/Factory_RGB_gray_NT2.png';
import Factory_RGB_green_NT2 from '../assets/images/Factory_RGB_green_NT2.png';
import Shipping_RGB_gray_NT from '../assets/images/Shipping_RGB_gray_NT.png';
import Shipping_RGB_blue_NT from '../assets/images/Shipping_RGB_blue_NT.png';
import Shipping_RGB_green_NT from '../assets/images/Shipping_RGB_green_NT.png';
import Bill_RGB_green_NT from '../assets/images/Bill_RGB_green_NT.png';
import train_icon from '../assets/images/train_icon.png';
import airplane from '../assets/images/airplane.png';
import vessel from '../assets/images/vessel.png';
import house_gray from '../assets/images/house_gray.png';
import house_green from '../assets/images/house_green.png';
import blue_arrow_right_line from '../assets/images/blue_arrow_right_line.png';
import blue_arrow_right_end from '../assets/images/blue_arrow_right_end.png';
import gray_arrow_right_line from '../assets/images/gray_arrow_right_line.png';
import xdock from '../assets/images/xdock.png';
import xdock_blue from '../assets/images/xdock_blue.png';
import factory from '../assets/images/factory.png';
import Dollar_green from '../assets/images/Dollar_green.png';
import Dollar_red from '../assets/images/Dollar_red.png';
import Dollar_blue from '../assets/images/Dollar_blue.png';
import gray_arrow_right_end from '../assets/images/gray_arrow_right_end.png';
import Bill_RGB_blue_NT from '../assets/images/Bill_RGB_blue_NT.png';
import spinning_small from '../assets/images/spinning_small.gif';
import lock_green from '../assets/images/lock_green.png';
import lock_yellow from '../assets/images/lock_yellow.png';
import lock_red from '../assets/images/lock_red.png';
import lock_grey from '../assets/images/lock_grey.png';

//svg icons
import { SubscribeIcon } from '../common/icons.jsx';

import '../vendors/q2cui_oss.js';
var _ = require('lodash');

//jsx common 
import {ModalWidgetWaiting, ModalWithClose, Modal, ModalTitle, ModalBody, ModalFooter, L, 
        InitSFDCWorkflow, StatusElement,
        Tab, TabBar, DDLabel,
        LabelGrid, SimpleDataGrid, ExportExtExcelOrder,Progress, BasicAlert, Loading, Checkbox } from '../common/components.jsx';

// GEGA TODO MFGListPopUp from components!!!!

//js common
import * as OSWidgetLib from '../common/osWidgetLib.js';
import '../common/plugins.js';

// osWidget_locales.js
//import {I18NFile} from '../common/osWidget_locales_HPI.js'

// GEGA T and I18N defined in wepack config as global available
import {fmDate, fmDateTime, fmNum} from '../common/i18n.js';
import { ShipToAddress } from './iShipToAddress.jsx';
import { Dates         } from './hDates.jsx';

/*----------------------------------------------------------------------------
|
|   OSS Widget external implementation
|
|
|   written by Jochen Loewer and Adolf Krauss
|   July 2014
|
\--------------------------------------------------------------------------*/

var UserSettings = {};
var DrillDownData = null;
var DrillDownColumns = null;
var state;

if (typeof state == "undefined") {
    state  = {}
}
state.fields = ["order_no","purchase_order_no"];

var showCustomizeDlg = false;
var MainGrid = null;
var subscreen = 'header';

function FetchUserSettings(next) {

  GET('/os/ossui/v1/ex/usersettings', '', function(response) {
    UserSettings = response;

    $("#InitMsg").show();
    return next();
  });
}

function DDErrorHandler(statusText, responseObj, responseText) {
  console.log("Error loading data dictionary: " + statusText)
}

function fmAddress ( addressLines  ) {

   if (!addressLines || !(addressLines instanceof Array)) return "";

   return addressLines.map(function(line) {
      return <div className="addressLine">{line}</div>
   });
}

function fmArray (arr) {

   if (!arr || !(arr instanceof Array)) return "";

   return arr.map(function(line) {
       return <div>{line}</div>
   });
}

var handleCloseModal = function() {
  window.parent.postMessage('hp_close_orderstatus_widget', '*');
}

// Old Status Visualization code - Just for the Ext. mobile part(PWA)
class StatusElementOld extends React.Component {
  render() {
    var t = this.props.type;
    var id_value = this.props.value_id;   
    if (t == "H" || t == "hide") return (<span></span>);
    if (t == "F" || t == "future") return (
      <li id={id_value} className="future"><a>{this.props.children}</a></li>
    );
    if (t == "A" || t == "active") return (
      <li id={id_value} className="active"><a>{this.props.children}</a></li>
    );
    if (t == "S" || t == "seen") return (
      <li id={id_value} className="seen"><a>{this.props.children}</a></li>
    );
  }
};

class TimelineSpacer extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="timelineMiddleSpacer">&nbsp;</div>
    )
  }
};

export class TimelineInfo extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var statusTooltip = "Most recent event dates of your order";
    return (
      <div className="timelineMiddleInfo">
        <a className="tooltips" style={{ "paddingLeft":"17px" }}>{this.props.children}
          <div className="classic"><L>{statusTooltip}</L></div>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </a>
      </div>
    )
  }
};

export class TimelineEntry extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.date == '') {
      return (
        <div className="timelineMiddle timelineMiddleMissing">&nbsp;<br/><br/>{this.props.label}</div>
      )
    }
      return (
      <div className="timelineMiddle">{this.props.date}<br/><br/>{this.props.label}</div>
    )
  }
};

export class Timeline extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var order = this.props.order;
    var ship_status = this.props.order.ship_status;
        if(ship_status == 'PS'){
            var shipLabel = T('Last Shipped');
            var podLabel  = T('Last Delivered');
        }else{
            var shipLabel = T('Shipped');
            var podLabel  = T('Delivered');
        }
    return (
       <div className="timeline">
          <TimelineEntry date={fmDate(order.purch_order_date)} label={T('Purchased')}/>
          <TimelineEntry date={fmDate(order.clean_order_date)}    label={T('Clean Order')}/>
          <TimelineEntry date={fmDate(order.customer_ship_date)}  label={shipLabel}/>
          <TimelineEntry date={fmDate(order.pod_date)}            label={podLabel}/>
          <TimelineInfo/>
       </div>
    )
  }
};

class TopStatusSection extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      shipment_nos: [],
      packingListToggleEnabled: false
    };

    this.handleDownload         = this.handleDownload.bind(this);
    this.handleOpenInvoiceList  = this.handleOpenInvoiceList.bind(this);
    this.handleDownloadPacklist = this.handleDownloadPacklist.bind(this);
    this.handleDownloadMfgData  = this.handleDownloadMfgData.bind(this);
    this.handleMfgDataList      = this.handleMfgDataList.bind(this);
    this.handleShipmentList     = this.handleShipmentList.bind(this);
    this.handleTracknTrace      = this.handleTracknTrace.bind(this);
    this.handlePodImage         = this.handlePodImage.bind(this);
    this.handleMassDL           = this.handleMassDL.bind(this);
    this.handlePackingListToggle = this.handlePackingListToggle.bind(this);
  }

  handlePackingListToggle  = e => {
    this.setState((prevState) => ({
      packingListToggleEnabled: !prevState.packingListToggleEnabled,
    }));
  };

  handleMassDL = e => {
    e.preventDefault();

    var order_no  = this.props.order.order_no;
    var massDLNos = this.state.shipment_nos;
    var uniqueMassDLNos = []

    for (var i = 0; i < massDLNos.length; i++) {
      if (massDLNos[i].shipment_no && massDLNos[i].shipment_no != "") {
        if(uniqueMassDLNos.indexOf(massDLNos[i].shipment_no) === -1) {
          uniqueMassDLNos.push(massDLNos[i].shipment_no);
        }
      }
    } 

    axios.post('/os/ossui/v1/ex/massDL/createSerialReport', {
      id: "", 
      name: "OSWidget_" + order_no, 
      description: "", 
      type: e.target.name, 
      values: {
                file: "n/a",
                method: "paste",
                values: uniqueMassDLNos
              }
    })
    .then(response => {
      var message = response.data.name + " submitted for processing";
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
    })
    .catch(error => {
      toast.error(error.response.statusText, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
    });
  };

  handleDownload() {

    var param = '';
    var prefix = '';

    if (this.props.b2bparameters) {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }

    if (sfdcSession) {
      param = '&sfdcSession='+sfdcSession
      prefix = '/os/';
    }

    if (window.extMobileMode) {
      window.open (location.origin + "/os/invoiceStatusExt.html?legacy_order_no="+this.props.order.legacy_order_no+"&language="+I18N.locale+"&type=ex&order_no="+this.props.order.order_no+param,"downloadwindow","menubar=1,resizable=1,width=450,height=450");

    } else {
      window.open (RewriteRESTURL(prefix + "invoiceStatusExt.html?legacy_order_no="+this.props.order.legacy_order_no+"&language="+I18N.locale+"&type=ex&order_no="+this.props.order.order_no+param),"downloadwindow","menubar=1,resizable=1,width=450,height=450");
    }
  }

  handleOpenInvoiceList() {

    var baseUrl = "/os/ossui/";

    var myWidgetMode = "external";
    if (this.props.myWidgetMode) {
      myWidgetMode = this.props.myWidgetMode;
    }

    if ((typeof WidgetMode !== 'undefined' && (WidgetMode == 'onetime') || myWidgetMode == 'public')) {
      return;                                                     
    }        

    var data_source = this.props.order.data_source;

    var params    = {};

    var b2bparameters = null;
    if (this.props.b2bparameters) {
      params.b2bparameters = this.props.b2bparameters; 
      b2bparameters = this.props.b2bparameters;
    }    

    $("#downloadAllInvs").hide();

    var getInvoicesURL = baseUrl + "v1/ex/getInvoices/"+this.props.order.legacy_order_no;
    if (sfdcSession) {
      getInvoicesURL  =  baseUrl + "v1/ex/getInvoices/"+this.props.order.legacy_order_no
                      + "?sfdcSession="+ sfdcSession;
    }

    var self = this;

    GET(getInvoicesURL, params, function(resp) {
      if (resp.status == 'N') {
       // alert(resp.message);
        $("#resultMsg").html(resp.message);
        $("#resultMsg").addClass("alert alert-danger");
      } else {


        // CR17221 - hide invoice download to end users for DMFI orders
        var hideDownloadAllInvs = false;
        var forbidInvDownload = 'N';
        if (self.props.order.aaid == 'ihp2b' && self.props.order.is_hp2b_partner == 'N'  
            && (self.props.order.trade_model == 'DMFi'
                || self.props.order.trade_model == 'Multichannel DMFi'
                || self.props.order.trade_model == 'Multichannel STM')
        ) {
            forbidInvDownload = 'Y';
            hideDownloadAllInvs = true;
        }

        resp.data.map( function(row) {
          if (row.net_price == null) {
            hideDownloadAllInvs = true;
          }
        });

        if (hideDownloadAllInvs) {
          $("#downloadAllInvs").hide();
        } else {
          $("#downloadAllInvs").show();
        }

        ReactDOM.render(
          <InvoiceListPopUp
            invoiceList={resp.data}
            invoiceStatus={status}
            data_source={data_source}
            forbidInvDownload={forbidInvDownload}
            b2bparameters={b2bparameters} />
          , document.getElementById('invoice')
        );
      }
    });
  }

  handleDownloadPacklist() {

    var param = '';
    if (this.props.b2bparameters) {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }

    if (sfdcSession) {
      param = '&sfdcSession='+sfdcSession
    }

    if (window.extMobileMode) {
      window.open (location.origin + "/os/shipmentPackListExt.html?legacy_order_no="+this.props.order.legacy_order_no+"&orderNo="+this.props.order.order_no+"&language="+I18N.locale+param+"&type=ex","downloadwindow","menubar=1,resizable=1,width=450,height=450");

    } else {
      window.open (RewriteRESTURL("shipmentPackListExt.html?legacy_order_no="+this.props.order.legacy_order_no+"&orderNo="+this.props.order.order_no+"&language="+I18N.locale+param+"&type=ex"),"downloadwindow","menubar=1,resizable=1,width=450,height=450");
    }
  }

  handleDownloadMfgData() {

    var param = '';
    if (this.props.b2bparameters) {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }

    if (sfdcSession) {
      param = '&sfdcSession='+sfdcSession
    }

    if (window.extMobileMode) {
      window.open (location.origin + "/os/ossui/v1/ex/exportMFGDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale,"downloadwindow","menubar=1,resizable=1,width=450,height=450");

    } else {
      window.open (RewriteRESTURL("/os/ossui/v1/ex/exportMFGDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale),"downloadwindow","menubar=1,resizable=1,width=450,height=450");
    }
  }

  handleMfgDataList() {

    var myWidgetMode = "external";
    if (this.props.myWidgetMode) {
      myWidgetMode = this.props.myWidgetMode;
    }

    if ((typeof WidgetMode !== 'undefined' && (WidgetMode == 'onetime') || myWidgetMode == 'public')) {
      return;                                                     
    }        

    var params = {};

    var URL = "/os/ossui/v1/ex/getMfgDataInfo/"+this.props.order.legacy_order_no;
    if (this.props.b2bparameters) {
      params.b2bparameters = this.props.b2bparameters;
    }

    GET(URL, params, function(res) {

      if (res.status == 'N') {
         $("#mfgdetail").hide();
         $("#mfgResultMsg").html(res.message);
         $("#mfgResultMsg").addClass("alert alert-danger");
      } else {

        $("#mfgResultMsg").empty();
        $("#mfgResultMsg").removeClass("alert alert-danger");

        ReactDOM.render(
          <MFGListPopUp
            mfgList={res.data}/>
          , document.getElementById('mfgdetail')
        );

        $("#mfgdetail").show();
      }
    }.bind(this));
  }

  handleShipmentList() {

    var params = {};
    params = getQueryParams(document.location.search);

    var URL = "/os/ossui/v1/ex/getShipmentInfo/"+this.props.order.legacy_order_no;

    if (this.props.b2bparameters) {
      params.b2bparameters = this.props.b2bparameters;
    }
    if (this.props.sfdcSignedRequest || sfdcSession) {
      params.signedRequest = this.props.sfdcSignedRequest;
      URL = "/os/api/widget/sfdc/getShipmentInfo/"+this.props.order.legacy_order_no;
    }
    if (sfdcSession) {
      URL = "/os/ossui/v1/ex/getShipmentInfo/"+this.props.order.legacy_order_no;
    }

    if (params.b2bparameters) {
      //URL = "/os/ossui/v1/ex/getShipmentInfo/"+this.props.order.legacy_order_no+"?b2bparameters=" + encodeURIComponent( params.b2bparameters );
    }

    if (typeof OnetimeWidget !== 'undefined' && OnetimeWidget && OnetimeWidget.k) {
        params.k = OnetimeWidget.k;
        params.o = OnetimeWidget.o;
    }

    $("#shipmentResultMsg").empty();
    $("#shipmentResultMsg").removeClass("alert alert-danger");

    ReactDOM.render(
      <BasicAlert type="L" />
      , document.getElementById('shipmentdet')
    );

    GET(URL, params, function(res) {

      if (res.status == 'N') {
         $("#shipmentResultMsg").html(res.message);
         $("#shipmentResultMsg").addClass("alert alert-danger");
      } else {

        var myWidgetMode;
        if (this.props.myWidgetMode != "public") {
          myWidgetMode = "external";
        } else {
          myWidgetMode = "public";
        }

        var shipment_nos = [];
        for (var i = 0; i < res.data.length; i++) {
          shipment_nos.push({order_no: this.props.order.order_no, shipment_no: res.data[i].shipmentno});
        }

        this.setState({
          shipment_nos: shipment_nos,
        });

        ReactDOM.render(
          <ShipmentListPopUp
            legacy_order_no={this.props.order.legacy_order_no}
            order_no={this.props.order.order_no}
            callerArea={myWidgetMode}
            shipmentList={res.data}
            OMSystem={this.props.order.om_system}
            handlePodImage={this.handlePodImage}
            TATPreURL={res.podurl}
            orderAAID={this.props.order.aaid}
            b2bparameters={this.props.b2bparameters} />
          , document.getElementById('shipmentdet')
        );
      }
    }.bind(this));
  }


  handleTracknTrace(hpLegacyOrderNo,shipmentno,trackingno) {

    var params    = {};
    if (this.props.b2bparameters) {
      params.b2bparameters = this.props.b2bparameters;
    }

    GET ("/os/ossui/v1/ex/trackInfo?legacy_order_no=" + hpLegacyOrderNo + "&shipment_no=" + shipmentno + "&trackingno=" + trackingno, params,function(res){
     if ( res.Trackinfo.status == "E") {

      $("#resultMsg").html(res.Trackinfo.Message);
      $("#resultMsg").addClass("alert alert-danger");

     } else {

      var tnturl = res.Trackinfo[trackingno].tat_url;

      if (tnturl != "" ) {
      var urlFlag = confirm("You are about to leave HP's website!\nHP is not responsible for information outside the HP website.");
      if (urlFlag == true) {
          window.open(tnturl, '_blank', 'width=700,height=500,toolbar=0,location=0,menubar=0');
          }
        } else {
          alert("Track and Trace url is not available for shipment number " + shipmentno +" and  tracking number " + trackingno);
        }
     }
   });
    event.preventDefault();
  }

  handlePodImage( legacyorderno, shipmentno, carriername, trackingno, hpdeliveryno, tatextpreurl) {

    var param = '';
    if (this.props.b2bparameters && this.props.b2bparameters != "") {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }
    var podUrl = "";
    podUrl = tatextpreurl + "pod=" + hpdeliveryno + "&carrier=" + carriername + "&shipmentno=" + shipmentno + "&pod_ship=" + shipmentno + "&pod_os=" + legacyorderno +param
    window.open (podUrl,"downloadwindow","menubar=1,resizable=1,width=450,height=450");
    event.preventDefault();
  }

   componentDidMount() {
    if (this.props.order.tenant != "HPICS") {
      if ( document.querySelector('#ShipmentScheduled') != null ) {
        document.querySelector('#ShipmentScheduled').setAttribute('style','display:none');
      }
    } else{
      if ( document.querySelector('#Production') != null ) {
        document.querySelector('#Production').setAttribute('style','display:none');
      }
    }
  }


  render() {

    var myWidgetMode = "external";
    if (this.props.myWidgetMode) {
      myWidgetMode = this.props.myWidgetMode;
    }

    var invoiceCount   = 0;
    var invoice_status = this.props.order.invoice_status;
    var ship_status    = this.props.order.ship_status;

    var params = {};
    params = getQueryParams(document.location.search);

    var patt = new RegExp("SAP-FAP2");
    var patt1 = new RegExp("SAP-AP");
    var patt2 = new RegExp("QAD-.*");

    var slimDropdown = { "padding": "2px 6px 1px 6px" };

    var invStatus = "Nothing<br>invoiced";
    var invStatusinPopup = "";

    if (invoice_status == "PI") {
      invStatus = "Partially<br>invoiced";
      invStatusinPopup = "(Partially invoiced)";
    }

    if (invoice_status == "FI") { invStatus = "Fully<br>invoiced"     }

    var alertMessage = T("Sensitive information – please login via the HP portal to view this!");
    // define invoice icon/dropdown section

    var invStatDropDown = "dropdown"
    if ((typeof WidgetMode !== 'undefined' && (WidgetMode == 'onetime') || myWidgetMode == 'public')) { 
        invStatDropDown = "";
        var invIcon = <img height="32" src={Bill_RGB_gray_NT} title={alertMessage}/>;
        if (invoice_status == "PI") { invIcon = <img height="32" src={Bill_RGB_blue_NT}  title={alertMessage}/> }
        if (invoice_status == "FI") { invIcon = <img height="32" src={Bill_RGB_green_NT} title={alertMessage}/> }
    } else {
        var invIcon = <img height="32" src={Bill_RGB_gray_NT}/>;
        if (invoice_status == "PI") { invIcon = <a id="invdrop" role="button" data-toggle={invStatDropDown} style={slimDropdown} href="#" onClick={this.handleOpenInvoiceList}><img height="32" src={Bill_RGB_blue_NT}/></a> }
        if (invoice_status == "FI") { invIcon = <a id="invdrop" role="button" data-toggle={invStatDropDown} style={slimDropdown} href="#" onClick={this.handleOpenInvoiceList}><img height="32" src={Bill_RGB_green_NT}/></a> }
    }

    // define mfg icon/dropdown section
    var mfgStatus = "Mfg<br>Data";

    var mfgDropDown = "dropdown";
    if ((typeof WidgetMode !== 'undefined' && (WidgetMode == 'onetime') || myWidgetMode == 'public')) { 
        mfgDropDown = "";
        if (this.props.order.nr_of_serials && this.props.order.nr_of_serials > 0) {
          var mfgIcon = <img height="32" src={Factory_RGB_green_NT2} title={alertMessage}/>            
        } else {
          var mfgIcon = <img height="32" src={Factory_RGB_gray_NT2}  title={alertMessage}/>            
        }
    } else {
      var mfgIcon = <img height="32" src={Factory_RGB_gray_NT2}/>
      if (this.props.order.nr_of_serials && this.props.order.nr_of_serials > 0) {
        var mfgIcon = <a id="mfgdrop" role="button" data-toggle={mfgDropDown} style={slimDropdown} href="#" onClick={this.handleMfgDataList}><img height="32" src={Factory_RGB_green_NT2}/></a>
      }
    }

    // define shipment icon/dropdown section
    var exportXLURL = RewriteRESTURL("/os/ossui/v1/ex/exportShipmentDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale);

    if (this.props.b2bparameters && this.props.b2bparameters != "") {
      exportXLURL = "/os/ossui/v1/ex/exportShipmentDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale + "?b2bparameters=" + encodeURIComponent( this.props.b2bparameters );
    } else
    if (params.callingSystem && params.callingSystem != "") {
      exportXLURL = "/os/ossui/v1/ex/exportShipmentDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale + "?callingSystem=" + encodeURIComponent( params.callingSystem );
    }

    if (sfdcSession) {
      var exportXLURL = "/os/ossui/v1/ex/exportShipmentDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale
                      + "?sfdcSession="+ sfdcSession;
    }
    if (params.k) {
      var exportXLURL = "/os/ossui/v1/ex/exportShipmentDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale
                      + "?k=" + params.k + "&o=" + params.o;
    }

    if ( myWidgetMode == "public" ) {
      var downloadShipmentButton = ""
      var downloadPacklistButton = ""
      var downloadPODsButton     = ""
    } else {
      var downloadShipmentButton =
        <a href={exportXLURL} target="_blank" title={T('DownloadShipmentDataToolTip')} className="btn btn-danger" style={{ "color": "white"}}>{T('Shipment Details')}</a>

      var massDLClass = "btn btn-danger disabled"
      if (this.state.shipment_nos.length > 0) {
        massDLClass = "btn btn-danger"
      }

      if (this.state.packingListToggleEnabled) {
        var downloadPacklistButton =
          <a className="btn btn-danger" style={{"padding": "1px 10px"}} onClick={this.handleDownloadPacklist}>{T('Packing Lists Direct')}</a>
      } else {
        var downloadPacklistButton =
          <a className={massDLClass} style={{padding:"1px 10px"}} onClick={this.handleMassDL} title="mass download Packing Lists" name="packing-list">{T('Packing Lists')}</a>
      }

      var downloadPODsButton = 
        <a className={massDLClass} onClick={this.handleMassDL} title="mass download POD Docs" name="pod-docs">{T('All PODs')}</a>

    }

    var shpStatus = "Nothing<br>shipped";
    if (ship_status == "PS") { shpStatus = "Partially<br>shipped" }
    if (ship_status == "FS") { shpStatus = "Fully<br>shipped"     }

    var shipIcon = <img height="24" src={Shipping_RGB_gray_NT}/>;

    var shipStatDropDown = "dropdown"

    if (ship_status == "PS") { shipIcon = <a id="shipdrpdwn" role="button" data-toggle={shipStatDropDown} style={slimDropdown} href="#" onClick={this.handleShipmentList}><img height="24" src={Shipping_RGB_blue_NT} /></a> }
    if (ship_status == "FS") { shipIcon = <a id="shipdrpdwn" role="button" data-toggle={shipStatDropDown} style={slimDropdown} href="#" onClick={this.handleShipmentList}><img height="24" src={Shipping_RGB_green_NT}/></a> }


    // status mapping for Widget top section
    var map = "FFFFFHH";  // F=future, S=seen, A=active, H=hide T=Tooltip
    var s = this.props.order.order_overall_status;

    //                                  +---------------Submitted
    //                                  |+--------------Accepted
    //                                  ||+-------------Production
    //                                  |||+------------Shipped to Customer
    //                                  ||||+-----------Delivered
    //                                  |||||+----------ShipmentCanceled
    //                                  ||||||+---------Canceled
    if (s == "Canceled"      ) { map = "SHHHHHA"; } else
    if (s == "CANCELED"      ) { map = "SHHHHHA"; } else
    if (s == "Delivered"     ) { map = "SSSSAHH"; } else
    if (s == "Shipped"       ) { map = "SSSAFHH"; } else
    if (s == "Consolidation" ) { map = "SSSAFHH"; } else
    if (s == "Registered"    ) { map = "SSAFFHH"; } else
    if (s == "FactShipped"   ) { map = "SSAFFHH"; } else
    if (s == "ProductionDone") { map = "SSAFFHH"; } else
    if (s == "Production"    ) { map = "SSAFFHH"; } else
    if (s == "ShipmentScheduled") { map = "SSAFFHH"; } else
    if (s == "Acked"         ) { map = "SAFFFHH"; } else
    if (s == "Processing"    ) { map = "SAFFFHH"; } else
    if (s == "Submitted"     ) { map = "AFFFFHH"; } else
    if (s == "ShipmentCanceled") { map = "SSSSHAH"; }

    var statusTooltip = "This reflects the status of the longest lead time item on your order";
    var lookupType = "legacy_order_no";
    var legacyOrderNo = this.props.order.legacy_order_no;
    var handleDownloadAllInvs = this.handleDownload;

    var stop_chg = this.props.order.stop_change_flag;
    var cons = this.props.order.consolidated_stati;
    var c    = this.props.order.credit_status;

    if ( c.match(/CreditApproved/)
      || ( ( s == "Consolidation" 
        || s == "Registered" 
        || s == "FactShipped" 
        || s == "Shipped" 
        || s == "Delivered" )  
      && !c.match(/Credit/) )
    ) {
        var creIcon  = <img height="38" src={Dollar_green}/>;
        var creStatus = "Credit<br>approved";
    } else
    if ( c.match(/CreditRejected/)
    ) {
        var creIcon  = <img height="38" src={Dollar_red}/>;
        var creStatus = "Credit<br>rejected";
    } else 
    if ( c.match(/CreditUnderValidation/)
    ) {
        var creIcon  = <img height="38" src={Dollar_blue}/>;
        var creStatus = "Credit under<br>validation";
    } else {
        var creIcon  = <img height="38" src={Dollar_blue}/>;
        var creStatus = "Credit under<br>validation";
    } 

    if ( stop_chg == 'PC' && this.props.order.om_system == 'SAP-SCP' ) {
      var stopChgIcon = <img height="38" src={lock_yellow}/>;
      var stopChgStatus = "Changes Partially Allowed"
    } else
    if ( stop_chg == 'NC' && this.props.order.om_system == 'SAP-SCP'
    ) {
      var stopChgIcon = <img height="38" src={lock_red}/>;
      var stopChgStatus = "No Changes Allowed"
    } else 
    if ( stop_chg == 'FC' && this.props.order.om_system == 'SAP-SCP'
    ) {
      var stopChgIcon = <img height="38" src={lock_green}/>;
      var stopChgStatus = "Changes Allowed"
    } else {
      var stopChgIcon = "";
      var stopChgStatus = "";
    }

    var progressionWidth = '85%';
    var showTooltip = true;
    if (window.extMobileMode) {
      progressionWidth = '97%';
      showTooltip = false;
    }

    return (
      <div>
        <table className="topstatus" width="100%">
        <tbody className="topstatus_body">
          <tr>
            <td style={{ "width": {progressionWidth}, "verticalAlign": "bottom", "align": "left" }}>
                <div className="progression">
                    <ul>
                      <StatusElementOld value_id={"Submitted"} type={map[0]}>         <L>Submitted</L>          </StatusElementOld>
                      <StatusElementOld value_id={"Processing"} type={map[1]}>         <L>Processing</L>          </StatusElementOld>
                      <StatusElementOld value_id={"ShipmentScheduled"} type={map[2]}> <L>ShipmentScheduled</L>  </StatusElementOld>
                      <StatusElementOld value_id={"Production"} type={map[2]}>        <L>Production</L>         </StatusElementOld>
                      <StatusElementOld value_id={"ShippedtoCustomer"} type={map[3]}> <L>Shipped to Customer</L></StatusElementOld>
                      <StatusElementOld value_id={"Delivered"} type={map[4]}>         <L>Delivered</L>          </StatusElementOld>
                      <StatusElementOld value_id={"ShipmentCanceled"} type={map[5]}>  <L>Shipment Canceled</L>  </StatusElementOld>
                      <StatusElementOld value_id={"Cancelled"} type={map[6]}>         <L>Cancelled</L>          </StatusElementOld>
                      {
                        showTooltip ?
                        <li className="tooltiphead">
                          <a className="tooltips" >{this.props.children}
                            <div className="classic" style={{ "whiteSpace": "normal"}}>{statusTooltip}</div>
                          </a>
                        </li>
                        : null
                      }
                    </ul>
                </div>
            </td>
            <td className='statuslabel' style={{ "verticalAlign": "bottom", "align": "left"}}>{stopChgIcon}</td>
            <td className='statuslabel' style={{ "verticalAlign": "bottom", "align": "left"}}>{creIcon}</td>
            <td className='statuslabel' style={{ "verticalAlign": "bottom", "align": "left"}}>
              <ul className="nav nav-dropWin">
                <li className="dropdown">
                  {mfgIcon}
                  <ul id="menumfg" className="dropdown-menu pull-right" role="menu" aria-labelledby="mfgdrop" style={{"right": "-100px"}}>
                  <div className="dropInfoWin">
                      <div className="modal-header">
                        <MfgPopupWrapperClass
                          order={this.props.order}
                          b2bparameters = {this.props.b2bparameters} />
                      </div>
                      <div id="mfgResultMsg"></div>
                      <div id="mfgdetail" style={{ "margin": "15px"}}></div>
                    </div>
                  </ul>
                </li>
              </ul>
            </td>
            <td className='statuslabel' style={{ "verticalAlign": "bottom", "align": "left"}}>
            <ul className="nav nav-dropWin">
                <li className="dropdown">
                  {shipIcon}
                  <ul id="menushp" className="dropdown-menu pull-right" role="menu" aria-labelledby="shipdrpdwn">
                  <div className="dropInfoWin">
                      <div className="modal-header">
                        <h4 className="modal-title" style={{ "textAlign": "left"}}>
                          <div className="pull-left"><L>Shipment(s)</L> &nbsp;<L>{shpStatus}</L></div>
                          <div id="downloadShipData" className="pull-right">
                            {downloadPODsButton} &nbsp; 
                            {downloadShipmentButton} &nbsp; 
                            {downloadPacklistButton}
                            {/* <Checkbox isEnabled={this.state.packingListToggleEnabled} onChange={this.handlePackingListToggle} /> */}
                          </div>
                        </h4>
                      </div>
                      <div id="shipmentResultMsg"></div>
                      <div id="shipmentdet" style={{ margin:"7px", maxHeight: "435px", overflow: "auto" }}></div>
                    </div>
                  </ul>
                </li>
              </ul>
            </td>
              <td className='statuslabel' style={{ "verticalAlign": "bottom", "align": "left"}}>
              <ul className="nav nav-dropWin">
                <li className="dropdown">
                  {invIcon}
                  <ul id="menuinv" className="dropdown-menu pull-right" role="menu" aria-labelledby="invdrop">
                  <div className="dropInfoWin">
                      <div className="modal-header">
                        <InvoicePopupWrapperClass
                          invStatusinPopup={invStatusinPopup}
                          handleDownloadAllInvs={handleDownloadAllInvs}
                          order={this.props.order} />
                      </div>
                      <div id="resultMsg"></div>
                      <div id="invoice" style={{ "margin": "15px"}}></div>
                    </div>
                  </ul>
                </li>
              </ul>
            </td>
          </tr>

          <tr>
            <td>&nbsp;</td>
            <td className='statuslabel'><L>{stopChgStatus}</L></td> 
            <td className='statuslabel'><L>{creStatus}</L></td>  
            <td className='statuslabel'><L>{mfgStatus}</L></td>  
            <td className='statuslabel'><L>{shpStatus}</L></td>
            <td className='statuslabel'><L>{invStatus}</L></td>
          </tr>
        </tbody>
        </table>
        <ToastContainer />
      </div>
    ); 
  }
}


//------------------------------------------------------------------------
//  PolyEmailModal
//
//------------------------------------------------------------------------
class PolyEmailModal extends React.Component {

  constructor(props) {
    super(props);
    this.sendPolyEmail = this.sendPolyEmail.bind(this);
  }

  handleClosePolyEmailModal = e => {
    this.props.onClose && this.props.onClose(e);
  };


  // post to own sendEmailTemplate API
  sendPolyEmail() {

    var order = this.props.order;
    
    var add_to_email  = document.getElementById('to_email').value.replace(/\n/g, ',');
    var add_cc_email  = document.getElementById('cc_email').value.replace(/\n/g, ',');
    var add_bcc_email = document.getElementById('bcc_email').value.replace(/\n/g, ',');    


    if (order.end_customer_attention.email != "") {
        var sendEmail = order.end_customer_attention.email;
    } else {
        var sendEmail = order.sold_to_attention.email;
    } 

    if (add_to_email != "") {
        sendEmail = sendEmail + ", " + add_to_email
    }

    if ( sendEmail == "" ) {
        alert("Email address is empty. Email not sent!");
        return;
    }

    var sendEmailCc = add_cc_email;

    var sendEmailBcc = "";
    if (add_bcc_email != "") {
        sendEmailBcc = sendEmailBcc + ", " + add_bcc_email
    }

    var payload = {
      "forceSend"   : false,
      "qtcuid"      : order.legacy_order_no,
      "sendEmail"   : sendEmail,
      "sendEmailCc" : sendEmailCc,
      "sendEmailBcc": sendEmailBcc,
      "assetName"   : "Poly Welcome Letter",
      "locale"      : "en",
      "template"    :
      "/OrderStatusEmails/WW_PolyEmail/WelcomeLetter",
      "storeInDas"  : true,
      "bind"        : {}
    }

    toast.info("Validating welcome letter email to " + sendEmail, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    var currentUrl = '';
    var isArch     = false;
    if (typeof window !== 'undefined' && window.location) {
      currentUrl = window.location.href;
    }

    // Determine if we are in ARCH layer by checking URL
    const withoutProtocol = currentUrl.replace(/^https:\/\//, '');
    const match = withoutProtocol.match(/^([^.]+)/);

    if (match[0] == "oss-arch" ) {
      console.log("current layer is Arch so calling PROD email API to send Poly Welcome Letter");
      payload.archive = true;
    }

    POST('/os/ossui/v1/ex/widget/sendEmail', payload, function(res) {

        if (res.alreadySent) {
          var forceSend = confirm("Welcome Letter already sent to " + res.user_id + "! Do you want to send again?");

          if ( forceSend ) {

            payload.forceSend = true;
            POST('/os/ossui/v1/ex/widget/sendEmail', payload, function(res1) {
                  var message = "Email sent successfully!";
                  toast.success(message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });  
                  console.log('sendEmailTemplate successfully called for Poly Welcome Letter. Send to', order.sold_to_attention.email);
            }, function(err1) {
                console.log('sendEmailTemplate failed!', err1);
                var message = "Welcome email could not be sent!";
                toast.error(message, {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
            });
          }
        } else {
          var message = "Email sent successfully!";
          toast.success(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });  
          console.log('sendEmailTemplate successfully called for Poly Welcome Letter. Send to', order.sold_to_attention.email);
        }
    }, function(err) {
        //alert("Ups, something went wrong");
        console.log('sendEmailTemplate failed!', err);
        var message = "Welcome email could not be sent!";
        toast.error(message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
    });
  };


  render() {

    if (!this.props.show) {
      return null;
    }

    var order = this.props.order;

    if (order.end_customer_attention.email != "") {
        var sendEmail = order.end_customer_attention.email;
    } else {
        var sendEmail = order.sold_to_attention.email;
    } 

    return (

      <form id='polyEmailForm' className="form-horizontal" role="form" method="post" action="">
        <div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg" style={{marginTop:"10%"}}>
            <div className="modal-content" style={{textAlign:"left"}} >
              <div className="modal-header">
                <h3 className="modal-title" id="polyEmailModal">Send Poly Welcome Letter</h3>
              </div>
              <div className="modal-body">

                  <table className="formTable" style={{width:"100%"}}>
                    <tr>
                      <td colSpan="3" style={{"paddingTop":"1px"}}><span>Welcome Letter will be sent to <b>{sendEmail}</b>. If required you can add more recipients below.</span></td>
                    </tr>
                    <tr>
                      <td style={{"paddingTop":"8px"}}>Additional TO Recipients</td>
                      <td style={{"paddingTop":"8px"}}>Additional CC Recipients</td>
                      <td style={{"paddingTop":"8px"}}>Additional BCC Recipients</td>                                        
                    </tr>
                    <tr>
                      <td style={{"paddingTop":"3px", "paddingRight":"8px", "verticalAlign":"top"}}><textarea type="text" className="form-control" name="to_email"  id="to_email"  placeholder="enter email addresses separated by comma or space" rows="6"/></td>
                      <td style={{"paddingTop":"3px", "paddingRight":"8px", "verticalAlign":"top"}}><textarea type="text" className="form-control" name="cc_email"  id="cc_email"  placeholder="enter email addresses separated by comma or space" rows="6"/></td>
                      <td style={{"paddingTop":"3px", "paddingRight":"8px", "verticalAlign":"top"}}><textarea type="text" className="form-control" name="bcc_email" id="bcc_email" placeholder="enter email addresses separated by comma or space" rows="6"/></td>
                    </tr>
                  </table>

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" onClick = {this.sendPolyEmail}>Send Email</button>
                <button type="button" className="btn btn-danger"  onClick = {this.handleClosePolyEmailModal}      >Close</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    )
  }
}


//----------------------------------------------------------------------
//   OswiActions -- show action buttons - export, open in SAP, etc.
//
//----------------------------------------------------------------------
class OswiActions extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      show: false
    };

  }

  showModal = e => {
    this.setState({
      show: !this.state.show,
      type: e.target.name
    });
  };


  render() {

    var order = this.props.order;
    var UserSettings = this.props.userSettings;
    var myWidgetMode = "external";
    if (this.props.myWidgetMode) {
      myWidgetMode = this.props.myWidgetMode;
    }

    var submitRequestBtn = null;
    if (myWidgetMode != 'public' && !OSWidgetLib.ZMSOOrder(this.props.order)) {
      submitRequestBtn =  <>
                            <InitSFDCWorkflow style={{"paddingRight":"5px"}} order={order} class="btn-smallest" locale={I18N.locale} isExternalWidget={true} crpItems={this.props.crpItems} />
                          </>
    }

    var polyEmailBtn = null;
    if ((typeof window.WidgetMode !== 'undefined' && (WidgetMode == 'onetime')) || myWidgetMode == 'public') {
        // no poly welcome letter button
    } else {
        if (myWidgetMode == 'external' && OSWidgetLib.PolyServiceOrder(this.props.order)) {
            polyEmailBtn = <button style={{"display":"inline-block","paddingRight":"5px"}} 
                                   className = "btn btn-smallest btn-success" 
                                   title     = "Send Poly welcome letter to end-customer attention email" 
                                   onClick   = {this.showModal}
                                   >
                                   <i className = "glyphicon glyphicon-envelope"/>&nbsp;Welcome Email
                           </button>
        }
    }


    return (
      <div id="TopLineSegment_Buttons" style={{"display":"inline", "float": "right", "textAlign":"right", "paddingBottom": "10px"}}>
        {submitRequestBtn}
        {polyEmailBtn}
        <PolyEmailModal onClose={this.showModal} show={this.state.show} order={this.props.order} />
      </div>
    )
  }
}


//---------------------------------------------------------------------------------
//   StatusIcons -- show clickable status icons such as Lock, Dollar, Bill, etc.
//
//---------------------------------------------------------------------------------
class StatusIcons extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      shipment_nos: [],
      packingListToggleEnabled: false
    };

    this.getVizIcon                = this.getVizIcon.bind(this);
    this.handleDownloadMFGData     = this.handleDownloadMFGData.bind(this);
    this.handleMfgDataList         = this.handleMfgDataList.bind(this);
    this.handleMassDL              = this.handleMassDL.bind(this);
    this.handleDownloadPacklist    = this.handleDownloadPacklist.bind(this);
    this.handlePackingListToggle   = this.handlePackingListToggle.bind(this);
    this.handleShipmentList        = this.handleShipmentList.bind(this);
    this.handlePodImage            = this.handlePodImage.bind(this);
    this.handleOpenInvoiceList     = this.handleOpenInvoiceList.bind(this);
    this.handleDownloadAllInvs     = this.handleDownloadAllInvs.bind(this);
  }

  handlePackingListToggle  = e => {
    this.setState((prevState) => ({
      packingListToggleEnabled: !prevState.packingListToggleEnabled,
    }));
  };
 
  handleActiveItemsToggle(dataID){
    this.props.activeItemsToggle(dataID)
  }

  handleDownloadMFGData() {
    var param = '';
    if (this.props.b2bparameters) {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }

    if (sfdcSession) {
      param = '&sfdcSession='+sfdcSession
    }

    if (window.extMobileMode) {
      window.open (location.origin + "/os/ossui/v1/ex/exportMFGDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale,"downloadwindow","menubar=1,resizable=1,width=450,height=450");

    } else {
      window.open (RewriteRESTURL("/os/ossui/v1/ex/exportMFGDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale),"downloadwindow","menubar=1,resizable=1,width=450,height=450");
    }
  }

  handleMfgDataList() {

   var myWidgetMode = "external";
    if (this.props.myWidgetMode) {
      myWidgetMode = this.props.myWidgetMode;
    }

    if ((typeof WidgetMode !== 'undefined' && (WidgetMode == 'onetime') || myWidgetMode == 'public')) {
      return;                                                     
    }        

    var params = {};

    var URL = "/os/ossui/v1/ex/getMfgDataInfo/"+this.props.order.legacy_order_no;
    if (this.props.b2bparameters) {
      params.b2bparameters = this.props.b2bparameters;
    }

    GET(URL, params, function(res) {

      if (res.status == 'N') {
         $("#mfgdetail").hide();
         $("#mfgResultMsg").html(res.message);
         $("#mfgResultMsg").addClass("alert alert-danger");
      } else {

        $("#mfgResultMsg").empty();
        $("#mfgResultMsg").removeClass("alert alert-danger");

        ReactDOM.render(
          <MFGListPopUp
            mfgList={res.data}/>
          , document.getElementById('mfgdetail')
        );

        $("#mfgdetail").show();
      }
    }.bind(this));
  }

  handleMassDL = e => {
    e.preventDefault();

    var order_no  = this.props.order.order_no;
    var massDLNos = this.state.shipment_nos;
    var uniqueMassDLNos = []

    for (var i = 0; i < massDLNos.length; i++) {
      if (massDLNos[i].shipment_no && massDLNos[i].shipment_no != "") {
        if(uniqueMassDLNos.indexOf(massDLNos[i].shipment_no) === -1) {
          uniqueMassDLNos.push(massDLNos[i].shipment_no);
        }
      }
    } 

    axios.post('/os/ossui/v1/ex/massDL/createSerialReport', {
      id: "", 
      name: "OSWidget_" + order_no, 
      description: "", 
      type: e.target.name, 
      values: {
                file: "n/a",
                method: "paste",
                values: uniqueMassDLNos
              }
    })
    .then(response => {
      var message = response.data.name + " submitted for processing";
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
    })
    .catch(error => {
      toast.error(error.response.statusText, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
    });
  };

  handleDownloadPacklist() {
    var param = '';
    if (this.props.b2bparameters) {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }

    if (sfdcSession) {
      param = '&sfdcSession='+sfdcSession
    }

    if (window.extMobileMode) {
      window.open (location.origin + "/os/shipmentPackListExt.html?legacy_order_no="+this.props.order.legacy_order_no+"&orderNo="+this.props.order.order_no+"&language="+I18N.locale+param+"&type=ex","downloadwindow","menubar=1,resizable=1,width=450,height=450");

    } else {
      window.open (RewriteRESTURL("shipmentPackListExt.html?legacy_order_no="+this.props.order.legacy_order_no+"&orderNo="+this.props.order.order_no+"&language="+I18N.locale+param+"&type=ex"),"downloadwindow","menubar=1,resizable=1,width=450,height=450");
    }
  }

  handleShipmentList() {

    var params = {};
    params = getQueryParams(document.location.search);

    var URL = "/os/ossui/v1/ex/getShipmentInfo/"+this.props.order.legacy_order_no;

    if (this.props.b2bparameters) {
      params.b2bparameters = this.props.b2bparameters;
    }
    if (this.props.sfdcSignedRequest || sfdcSession) {
      params.signedRequest = this.props.sfdcSignedRequest;
      URL = "/os/api/widget/sfdc/getShipmentInfo/"+this.props.order.legacy_order_no;
    }
    if (sfdcSession) {
      URL = "/os/ossui/v1/ex/getShipmentInfo/"+this.props.order.legacy_order_no;
    }

    if (params.b2bparameters) {
      //URL = "/os/ossui/v1/ex/getShipmentInfo/"+this.props.order.legacy_order_no+"?b2bparameters=" + encodeURIComponent( params.b2bparameters );
    }

    if (typeof OnetimeWidget !== 'undefined' && OnetimeWidget && OnetimeWidget.k) {
        params.k = OnetimeWidget.k;
        params.o = OnetimeWidget.o;
    }

    $("#shipmentResultMsg").empty();
    $("#shipmentResultMsg").removeClass("alert alert-danger");
    ReactDOM.unmountComponentAtNode(document.getElementById('shipmentdet'));

    ReactDOM.render(
      <BasicAlert type="L" />
      , document.getElementById('shipmentdet')
    );

    GET(URL, params, function(res) {

      if (res.status == 'N') {
        $("#shipmentResultMsg").html(res.message);
        $("#shipmentResultMsg").addClass("alert alert-danger");
        ReactDOM.unmountComponentAtNode(document.getElementById('shipmentdet'));
      } else {

        var myWidgetMode;
        if (this.props.myWidgetMode != "public") {
          myWidgetMode = "external";
        } else {
          myWidgetMode = "public";
        }

        var shipment_nos = [];
        for (var i = 0; i < res.data.length; i++) {
          shipment_nos.push({order_no: this.props.order.order_no, shipment_no: res.data[i].shipmentno});
        }

        this.setState({
          shipment_nos: shipment_nos,
        });

        ReactDOM.render(
          <ShipmentListPopUp
            legacy_order_no={this.props.order.legacy_order_no}
            order_no={this.props.order.order_no}
            callerArea={myWidgetMode}
            shipmentList={res.data}
            OMSystem={this.props.order.om_system}
            handlePodImage={this.handlePodImage}
            TATPreURL={res.podurl}
            orderAAID={this.props.order.aaid}
            b2bparameters={this.props.b2bparameters} />
          , document.getElementById('shipmentdet')
        );
      }
    }.bind(this));
  }

  handlePodImage( legacyorderno, shipmentno, carriername, trackingno, hpdeliveryno ,TATPreURL) {
    var param = '';
    if (this.props.b2bparameters && this.props.b2bparameters != "") {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }
    var podUrl = "/os/podimg?shipment=" + shipmentno + "&lno=" + legacyorderno + "&ex=Y" + param;
    window.open (podUrl,"downloadwindow","menubar=1,resizable=1,width=750,height=590");
    event.preventDefault();
  }

  handleOpenInvoiceList() {
    
    var baseUrl = "/os/ossui/";

    var myWidgetMode = "external";
    if (this.props.myWidgetMode) {
      myWidgetMode = this.props.myWidgetMode;
    }

    if ((typeof WidgetMode !== 'undefined' && (WidgetMode == 'onetime') || myWidgetMode == 'public')) {
      return;                                                     
    }        

    var data_source = this.props.order.data_source;

    var params    = {};

    var b2bparameters = null;
    if (this.props.b2bparameters) {
      params.b2bparameters = this.props.b2bparameters; 
      b2bparameters = this.props.b2bparameters;
    }    

    $("#downloadAllInvs").hide();

    var getInvoicesURL = baseUrl + "v1/ex/getInvoices/"+this.props.order.legacy_order_no;
    if (sfdcSession) {
      getInvoicesURL  =  baseUrl + "v1/ex/getInvoices/"+this.props.order.legacy_order_no
                      + "?sfdcSession="+ sfdcSession;
    }

    var self = this;

    GET(getInvoicesURL, params, function(resp) {
      if (resp.status == 'N') {
       // alert(resp.message);
        $("#resultMsg").html(resp.message);
        $("#resultMsg").addClass("alert alert-danger");
      } else {

 
        // CR17221 - hide invoice download to end users for DMFI orders
        var hideDownloadAllInvs = false;
        var forbidInvDownload = 'N';
        if (self.props.order.aaid == 'ihp2b' && self.props.order.is_hp2b_partner == 'N'  
            && (self.props.order.trade_model == 'DMFi'
                || self.props.order.trade_model == 'Multichannel DMFi'
                || self.props.order.trade_model == 'Multichannel STM')
        ) {
            forbidInvDownload = 'Y';
            hideDownloadAllInvs = true;
        }

        resp.data.map( function(row) {
          if (row.net_price == null) {
            hideDownloadAllInvs = true;
          }
        });

        if (hideDownloadAllInvs) {
          $("#downloadAllInvs").hide();
        } else {
          $("#downloadAllInvs").show();
        }

        ReactDOM.render(
          <InvoiceListPopUp
            invoiceList={resp.data}
            invoiceStatus={status}
            data_source={data_source}
            forbidInvDownload={forbidInvDownload}
            b2bparameters={b2bparameters} />
          , document.getElementById('invoice')
        );
      }
    });
  }

  handleDownloadAllInvs() {
    var param = '';
    var prefix = '';

    if (this.props.b2bparameters) {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }

    if (sfdcSession) {
      param = '&sfdcSession='+sfdcSession
      prefix = '/os/';
    }

    if (window.extMobileMode) {
      window.open (location.origin + "/os/invoiceStatusExt.html?legacy_order_no="+this.props.order.legacy_order_no+"&language="+I18N.locale+"&type=ex&order_no="+this.props.order.order_no+param,"downloadwindow","menubar=1,resizable=1,width=450,height=450");

    } else {
      window.open (RewriteRESTURL(prefix + "invoiceStatusExt.html?legacy_order_no="+this.props.order.legacy_order_no+"&language="+I18N.locale+"&type=ex&order_no="+this.props.order.order_no+param),"downloadwindow","menubar=1,resizable=1,width=450,height=450");
    }
  }

  getVizIcon(iconCode){
    const icon = {};

    if (iconCode === 'credit_status') {
      // if credit status icon
      const os = this.props.order.order_overall_status;
      const cs = this.props.order.credit_status;

      if (
        cs.match(/CreditApproved/) ||
        ((os === "Consolidation" ||
          os === "Registered" ||
          os === "FactShipped" ||
          os === "Shipped" ||
          os === "Delivered") &&
          !cs.match(/Credit/))
      ) {
        icon.type = Dollar_green;
        icon.statusText = "Credit<br>approved"
      } else if (cs.match(/CreditRejected/)) {
        icon.type = Dollar_red;
        icon.statusText = "Credit<br>rejected";
      } else if (cs.match(/CreditUnderValidation/)) {
        icon.type = Dollar_blue;
        icon.statusText = "Credit under<br>validation";
      } else {
        icon.type = Dollar_blue;
        icon.statusText = "Credit under<br>validation";
      }

    } else if (iconCode === 'changes'){
      const stop_chg = this.props.order.stop_change_flag;
      const om_system = this.props.order.om_system;
      if ( stop_chg == 'PC' && om_system == 'SAP-SCP' ) {
        icon.type = lock_yellow;
        icon.statusText = "Changes Partially<br>Allowed";
      } else
      if ( stop_chg == 'NC' && om_system == 'SAP-SCP') {
        icon.type = lock_red;
        icon.statusText = "No Changes<br>Allowed";
      } else if ( stop_chg == 'FC' && om_system == 'SAP-SCP' ) {
        icon.type = lock_green;
        icon.statusText = "Changes<br>Allowed";
      } else {
        icon.type = lock_grey;
        icon.statusText = "SC_NA";
      }

    } else if (iconCode === 'mfg') {
        icon.type = Factory_RGB_gray_NT2;
        icon.statusText = "Mfg<br>Data";
        if ((this.props.order.nr_of_serials && this.props.order.nr_of_serials > 0 ) || (this.props.order.nr_of_trackids && this.props.order.nr_of_trackids > 0) ) {
          icon.type = Factory_RGB_green_NT2;
          icon.statusText = "Mfg<br>Data";
        }
    } else if (iconCode === 'shp') {
        const shpStatus = this.props.order.ship_status;

        icon.type = Shipping_RGB_gray_NT;
        icon.statusText = "Nothing<br>shipped";
        if (shpStatus == "PS") { 
          icon.type = Shipping_RGB_blue_NT;
          icon.statusText = "Partially<br>shipped";
        } else if (shpStatus == "FS") {
          icon.type = Shipping_RGB_green_NT;
          icon.statusText = "Fully<br>shipped";
        }
    } else if (iconCode === 'inv') {
      const invoice_status = this.props.order.invoice_status;
      icon.type = Bill_RGB_gray_NT;
      icon.statusText = 'Nothing<br>invoiced';

      if (invoice_status == "PI") {
        icon.type = Bill_RGB_blue_NT;
        icon.statusText = 'Partially<br>invoiced';
      } else if ( invoice_status == "FI" ){
        icon.type = Bill_RGB_green_NT;
        icon.statusText = 'Fully<br>invoiced';
      }
    }

    return icon;
  }

  render() {

    var myWidgetMode = "external";
    if (this.props.myWidgetMode) {
      myWidgetMode = this.props.myWidgetMode;
    }
    var params = {};
    params = getQueryParams(document.location.search);

    var iconStyle = { "padding": "2px 6px 1px 6px", "pointerEvents": "all" };

    // Enable MFG data download modal
    var mfgDropDown = "dropdown";
    if ((typeof WidgetMode !== 'undefined' && (WidgetMode == 'onetime') || myWidgetMode == 'public')) { 
      mfgDropDown = "";
    }

    if ((this.props.order.nr_of_serials && this.props.order.nr_of_serials > 0) || (this.props.order.nr_of_trackids && this.props.order.nr_of_trackids > 0) ) {
      var mfgIcon = 
        <a id="mfgdrop" role="button" className="ico-container" data-toggle={mfgDropDown} style={iconStyle} href="#" onClick={this.handleMfgDataList}>
          <img className="status-ico" height="32" src={this.getVizIcon('mfg').type} />
        </a>
    } else {
      var mfgIcon = <img className="status-ico" height="32" src={this.getVizIcon('mfg').type} />
    }

    var mfgModal =  
        <div className="dropdown nav-dropWin">
          {mfgIcon}
          <ul id="menumfg" className="dropdown-menu pull-right" role="menu" aria-labelledby="mfgdrop" style={{"right": "-100px"}}>
          <div className="dropInfoWin">
              <div className="modal-header">
                <MfgPopupWrapperClass
                  order={this.props.order}
                  b2bparameters = {this.props.b2bparameters} />
              </div>
              <div id="mfgResultMsg"></div>
              <div id="mfgdetail" style={{ "margin": "15px"}}></div>
            </div>
          </ul>
        </div>
                    

    // Shipment section

    var shpIcon =
        <a id="shipdrpdwn" role="button" className="ico-container" data-toggle="dropdown" style={iconStyle} href="#" onClick={this.handleShipmentList}>
          <img className="status-ico" height="26" src={this.getVizIcon('shp').type} />
        </a>

    var shpModal =
        <div className="dropdown nav-dropWin">
          {shpIcon}
          <ul id="menushp" className="dropdown-menu pull-right" role="menu" aria-labelledby="shipdrpdwn" style={{"right": "10px"}}>
          <div className="dropInfoWin">
              <div className="modal-header">
                <ShipmentPopupWrapperClass
                  handleMassDL={this.handleMassDL}
                  b2bparameters={this.props.b2bparameters}
                  order={this.props.order}
                  disableButtons={this.state.shipment_nos.length === 0}
                  showOrderText={false} />
              </div>
              <div id="shipmentResultMsg"></div>
              <div id="shipmentdet" style={{ margin: "7px", maxHeight: "435px", overflow: "auto"}}></div>
            </div>
          </ul>
        </div>

    // Invoice download
    var invIconStyle = { ...iconStyle, "marginLeft" : "10px" };
    var invStatDropDown = "dropdown"
    if ((typeof WidgetMode !== 'undefined' && (WidgetMode == 'onetime') || myWidgetMode == 'public')) { 
      invStatDropDown = "";
    }
    
    var invIcon =
        <a id="invdrop" style={invIconStyle} className="ico-container" role="button" data-toggle={invStatDropDown} href="#" onClick={this.handleOpenInvoiceList}>
          <img className="status-ico" height="32" src={this.getVizIcon('inv').type} />
        </a>

    var invModal =
        <div className="dropdown nav-dropWin">
          {invIcon}
          <ul id="menuinv" className="dropdown-menu pull-right" role="menu" aria-labelledby="invdrop" style={{"right": "67px"}}>
          <div className="dropInfoWin">
              <div className="modal-header">
                <InvoicePopupWrapperClass
                  invStatusinPopup={this.getVizIcon('inv').statusText}
                  handleDownloadAllInvs={this.handleDownloadAllInvs}
                  order={this.props.order} />
              </div>
              <div id="resultMsg"></div>
              <div id="invoice" style={{ "margin": "15px"}}>
              </div>
            </div>
          </ul>
        </div>

    var ecoTransportText = "Lower carbon<br>shipping."
    var ecoTransportIcon = null;

    if (this.props.order.ship_conditions == "EC" ) {
      ecoTransportIcon = <li className="statuslabel ico-container" title="This order carries one or several items handled with lower carbon shipping option.">
            <i className='fa-solid fa-leaf fac-green-dark' height = "32" style={{ 'height': '32px'}}></i>
            <span style={{'display': 'block'}}><L>{ecoTransportText}</L></span>
          </li>
    }

    return (
      <div id="statusIcons" style={{'display':'inline', 'paddingBottom': '10px', 'float': 'right'}}>
        <ul style={{"paddingLeft": "unset"}}>
          {ecoTransportIcon}
          <li className="statuslabel ico-container">
            <img className="status-ico" height="32" src={this.getVizIcon('credit_status').type} />
            <span style={{'display': 'block'}}><L>{this.getVizIcon('credit_status').statusText}</L></span>
          </li>
          <li className="statuslabel ico-container">
            <img className="status-ico" height="32" src={this.getVizIcon('changes').type} title={this.getVizIcon('changes').statusText.replace("<br>", " ")} />
            <span style={{'display': 'block'}}><L>{this.getVizIcon('changes').statusText}</L></span>
          </li>
          <li className="statuslabel">
            {mfgModal}
            <span><L>{this.getVizIcon('mfg').statusText}</L></span>
          </li>
          <li className="statuslabel">
            {shpModal}
            <span><L>{this.getVizIcon('shp').statusText}</L></span>
          </li>
          <li className="statuslabel">
            {invModal}
            <span><L>{this.getVizIcon('inv').statusText}</L></span>
          </li>
        </ul>
      </div>
    );
  }

}



//----------------------------------------------------------------------
//   StatusGraphic -- show visual quick status / animation
//
//----------------------------------------------------------------------
class StatusGraphic extends React.Component {

  constructor(props) {
    super(props);

    this.handleActiveItemsToggle   = this.handleActiveItemsToggle.bind(this);
  }
 
  handleActiveItemsToggle(dataID){
    this.props.activeItemsToggle(dataID)
  }

  render() {

    // SOM orders (Subscription Contract / Solution Quotation): dedicated status flow
    const orderType = this.props.order.order_type;
    if (orderType && orderType.startsWith('SOM-')) {
      const s = this.props.order.order_overall_status;
      const map = OSWidgetLib.getMappingFromStatus_SOM(s);
      var disabledButtons = { "pointerEvents": "none" };

      return (
      // status graphics for SOM Subscription / Solution Quotation orders
      <div id="StatusGraphic" style={{'display':'inline-block', 'paddingBottom': '10px'}}>
        <div className="statusButtons" data-toggle="buttons">
          <ul>
            <StatusElement type={map[0]} dataID="submitted" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[1]} dataID="pending"   tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[2]} dataID="active"    tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[3]} dataID="planned"   tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[4]} dataID="canceled"  tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[5]} dataID="expired"   tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
          </ul>
        </div>
        <div className="hint">
          <span className="ico-hint glyphicon glyphicon-info-sign"></span>
          <ul className="list-hint">
            <li className="title">Legend</li>
            <li><span className="key key-color clr-gray">Gray</span><span className="val">: Status not yet reached</span></li>
            <li><span className="key key-color clr-blue">Blue</span><span className="val">: Current status</span></li>
            <li><span className="key key-color clr-green">Green</span><span className="val">: Status completed</span></li>
            <li><span className="key key-color clr-red">Red</span><span className="val">: Canceled</span></li>
          </ul>
        </div>
      </div>
      );
    }

    // Order Change (ORDCHG): dedicated Submitted -> Completed status flow
    if (orderType === 'ORDCHG') {
      const s = this.props.order.order_overall_status;
      const map = OSWidgetLib.getMappingFromStatus_ORDCHG(s);
      var disabledButtons = { "pointerEvents": "none" };

      return (
      // status graphics for Order Change (ORDCHG) orders
      <div id="StatusGraphic" style={{'display':'inline-block', 'paddingBottom': '10px'}}>
        <div className="statusButtons" data-toggle="buttons">
          <ul>
            {this.props.order.hp_receive_date && <StatusElement type={map[0]} isBookmarkFlag><span title="HPRD" className="viz-flag"><span className="viz-bookmark-lbl lt">{fmDate(this.props.order.hp_receive_date)}</span></span></StatusElement>}
            <StatusElement type={map[0]} dataID="submitted" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[1]} dataID="completed" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            {this.props.order.order_close_date && <StatusElement type={map[1]} isBookmarkFlag><span title="Change Order Completed" className="viz-flag"><span className="viz-bookmark-lbl">{fmDate(this.props.order.order_close_date)}</span></span></StatusElement>}
          </ul>
        </div>
        <div className="hint">
          <span className="ico-hint glyphicon glyphicon-info-sign"></span>
          <ul className="list-hint">
            <li className="title">Legend</li>
            <li><span className="key key-color clr-gray">Gray</span><span className="val">: Status not yet reached</span></li>
            <li><span className="key key-color clr-blue">Blue</span><span className="val">: Current status</span></li>
            <li><span className="key key-color clr-green">Green</span><span className="val">: Status completed</span></li>
          </ul>
        </div>
      </div>
      );
    }

    var s = this.props.order.order_overall_status;
    const tenant = this.props.tenant;
    const serviceType = this.props.order.service_type;

    if (tenant == "HPICS" && isAdvancedExchangeServiceType(serviceType)) {
      var map = OSWidgetLib.getMappingFromStatus_CS_AdvExchange(s);
    } else {
      var map = OSWidgetLib.getMappingFromStatus(s);
    }

    if (tenant == "HPICS" && isAdvancedExchangeServiceType(serviceType)) {
      if(s === "Delivered" &&  this.props.order.pod_date) { map = "SCFFHH"}
    } else {
      if(s === "Delivered" &&  this.props.order.pod_date) { map = "SSSSSSHH"}
    }
    const deliveredDate = this.props.order.pod_date ? fmDate(this.props.order.pod_date) : 'Date: WIP';

    if (isAdvancedExchangeServiceType(serviceType)) {
      // do not change the map for HPICS adv exch flows
    } else {
      // hide consolidation when delivery_type is present in valuesToHideConsolidation array values
      const valuesToHideConsolidation = ['ship as available', 'ship as avail-via fixhubemea', 'ship as avail-via mit_emea'];
      if ((this.props.order.delivery_type)) {
        const delvType = this.props.order.delivery_type.toLowerCase();
        var hideConsolidationFlag = false;
        valuesToHideConsolidation.map((item) => {
          if (delvType.indexOf(item) > -1) {
            hideConsolidationFlag = true;
          }
        })
        if (hideConsolidationFlag) {
          map = map.substr(0, 3) + "H" + map.substr(4);
        }
      }
    }

    // mapping table only checks for order overall status
    // below line just manipulates the map so we can identify a non cancelled order but with cancelled items
    if (this.props.itemGroupsCount.canceled > 0) {
      map = map.replace(/.$/,"A");
    }

    if (this.props.itemGroupsCount.shipmentCanceled > 0) {
      map = map.substring(0, map.length-2) + "A" + map.substring(map.length-1);
    }

    var disabledButtons = { "pointerEvents": "none" };

    if (tenant == "HPICS" && isAdvancedExchangeServiceType(serviceType)) {

      return (      
      // status graphics for HPICS Standard/Advanced Exchange orders  
      <div id="StatusGraphic" style={{'display':'inline-block', 'paddingBottom': '10px'}}>
        <div className="statusButtons" data-toggle="buttons">
          <ul>
            {this.props.order.hp_receive_date && <StatusElement type={map[0]} isBookmarkFlag><span title="HPRD" className="viz-flag" > <span className="viz-bookmark-lbl lt">{fmDate(this.props.order.hp_receive_date)}</span></span></StatusElement>}
            <StatusElement type={map[0]} dataID="processing"        tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[1]} dataID="shippedToCustomer" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[2]} dataID="awaitingReturn"    tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[3]} dataID="received"          tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[4]} dataID="repairInProgress"  tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[5]} dataID="repairComplete"    tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[6]} dataID="shipmentCanceled"  tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[7]} dataID="canceled"          tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
          </ul>
        </div>
        <div className="hint">
          <span className="ico-hint glyphicon glyphicon-info-sign"></span>
          <ul className="list-hint">
            <li className="title">Legend</li>
            <li><span className="key key-color clr-gray">Gray</span><span className="val">: No item in this status</span></li>
            <li><span className="key key-color clr-blue">Blue</span><span className="val">: At least 1 item in this status</span></li>
            <li><span className="key key-color clr-green">Green</span><span className="val">: All items have moved past this status</span></li>
            <li><span className="key key-color clr-red">Red</span><span className="val">: Some items are cancelled</span></li>
            <li><span className="key ico-status-legend ico-credit-approved"></span><span className="val">: Credit status</span></li>
            <li><span className="key ico-status-legend ico-locked"></span><span className="val">: Changes status</span></li>
            <li><span className="key ico-status-legend ico-mfg"></span><span className="val">: Mfg Date</span></li>
            <li><span className="key ico-status-legend ico-not-invoiced"></span><span className="val">: Invoiced status</span></li>
          </ul>
        </div>
      </div>
      );

    } else {

      return (
      // status graphics for non HPICS Standard/Advanced Exchange orders  
      <div id="StatusGraphic" style={{'display':'inline-block', 'paddingBottom': '10px'}}>
        <div className="statusButtons" data-toggle="buttons">
          <ul>
            {this.props.order.hp_receive_date && <StatusElement type={map[0]} isBookmarkFlag><span title="HPRD" className="viz-flag" > <span className="viz-bookmark-lbl lt">{fmDate(this.props.order.hp_receive_date)}</span></span></StatusElement>}
            <StatusElement type={map[0]} dataID="submitted" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[1]} dataID="accepted"  tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            {this.props.order.clean_order_date && <StatusElement type={map[1]} isBookmarkFlag><span title="Complete Order Clean date" className="viz-flag" > <span className="viz-bookmark-lbl">{fmDate(this.props.order.clean_order_date)}</span></span></StatusElement>}
            {tenant !== 'HPICS' && (
              <StatusElement type={map[2]} dataID="production" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />)
            }
            {tenant === 'HPICS' && (
              <StatusElement type={map[2]} dataID="shipmentScheduled" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />)
            }
            <StatusElement type={map[3]} dataID="consolidation"     tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[4]} dataID="shippedToCustomer" tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            {this.props.order.customer_ship_date && <StatusElement type={map[4]} isBookmarkFlag><span title="Complete Order Ship date" className="viz-flag" > <span className="viz-bookmark-lbl">{fmDate(this.props.order.customer_ship_date)}</span></span></StatusElement>}
            <StatusElement type={map[5]} dataID="delivered"         tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            {this.props.order.pod_date && <StatusElement type={map[5]} isBookmarkFlag><span title="Complete Order Delivered" className="viz-flag" > <span className="viz-bookmark-lbl">{deliveredDate}</span></span></StatusElement>}
            <StatusElement type={map[6]} dataID="shipmentCanceled"  tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
            <StatusElement type={map[7]} dataID="canceled"          tenant={this.props.order.tenant} serviceType={this.props.order.service_type} itemGroupsCount={this.props.itemGroupsCount} activeItemButtons={this.props.activeItemButtons} handleActiveItemsToggle={this.handleActiveItemsToggle} style={disabledButtons} />
          </ul>
        </div>
        <div className="hint">
          <span className="ico-hint glyphicon glyphicon-info-sign"></span>
          <ul className="list-hint">
            <li className="title">Legend</li>
            <li><span className="key key-color clr-gray">Gray</span><span className="val">: No item in this status</span></li>
            <li><span className="key key-color clr-blue">Blue</span><span className="val">: At least 1 item in this status</span></li>
            <li><span className="key key-color clr-green">Green</span><span className="val">: All items have moved past this status</span></li>
            <li><span className="key key-color clr-red">Red</span><span className="val">: Some items are cancelled</span></li>
            <li><span className="key ico-status-legend ico-credit-approved"></span><span className="val">: Credit status</span></li>
            <li><span className="key ico-status-legend ico-locked"></span><span className="val">: Changes status</span></li>
            <li><span className="key ico-status-legend ico-mfg"></span><span className="val">: Mfg Date</span></li>
            <li><span className="key ico-status-legend ico-not-invoiced"></span><span className="val">: Invoiced status</span></li>
          </ul>
        </div>
      </div>
      );
    }

  }
};

class MfgPopupWrapperClass extends React.Component {

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.order.legacy_order_no != nextProps.order.legacy_order_no) {
    }
    return true;
  }

  render() {

    var exportXLURL = RewriteRESTURL("/os/ossui/v1/ex/exportMFGDataToExcelTitanium/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale);

    if (this.props.b2bparameters && this.props.b2bparameters != "") {
      exportXLURL = "/os/ossui/v1/ex/exportMFGDataToExcelTitanium/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale
                  + '?b2bparameters=' + encodeURIComponent( this.props.b2bparameters);
    }

    if (sfdcSession) {
      exportXLURL = "/os/ossui/v1/ex/exportMFGDataToExcelTitanium/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale
                  + "?sfdcSession="+ sfdcSession;
    }

    var downloadMFGButton =
      <a href={exportXLURL} target="_blank" title={T('DownloadManufacturingDataToolTip')} className="btn btn-danger" style={{ "color": "white"}}><L>Download Manufacturing Details</L></a>

    return (
      <h4 className="modal-title" style={{ "textAlign": "left"}}>
        <div className="pull-left"><L>Manufacturing Data</L></div>
        <div id="downloadMfgData" className="pull-right">
        {downloadMFGButton}
        </div>
      </h4>
    );
  }
};

class InvoicePopupWrapperClass extends React.Component {

//GEGA TODO, shouldComponentUpdate needed? download button never shows up?!

/*  getInitialState() {
    this.checkInvoiceSetup(this.props.order.legacy_order_no);
    return {displayOption: "none"};
  }*/
  constructor(props) {
    super(props);
    this.state = {
      displayOption: "none"
    };
    this.checkInvoiceSetup = this.checkInvoiceSetup.bind(this);
    //this.handleDownloadAllInvs = this.handleDownloadAllInvs.bind(this);
  }
  
  checkInvoiceSetup(legacyOrderNo) {
    var cb = function (res) {
      var displayOptionValue;
      try {
        if (res.status !== 'N') {
          displayOptionValue =
            !res.data.isAPJ ?
              "block" :
              (res.data.setups && res.data.setups.length > 0 ? "block" : "block")
        } else {
          displayOptionValue="block";
        }
      } catch (e) {
        displayOptionValue="block";
      }
      this.setState({displayOption:displayOptionValue});
    }.bind(this);

    var prefix = "/os/ossui/";

    var url = RewriteRESTURL(prefix + "v1/ex/getAPJOrderInvoicePDFSetup/" + legacyOrderNo );
    if (sfdcSession) {
      var url = prefix + "v1/ex/getAPJOrderInvoicePDFSetup/" + legacyOrderNo + "?sfdcSession="+ sfdcSession;
    }   
    var param = {};
    var currentWidgetParams = getQueryParams(document.location.search);
    if (currentWidgetParams.k && currentWidgetParams.o) {
        param = { k : currentWidgetParams.k, o: legacyOrderNo } ;
    }
    //console.log('etAPJOrderInvoicePDFSetup:', param); 
    GET(url, param, cb);
  }

  /*  GEGA instead use componentDidMount 
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.order.legacy_order_no != nextProps.order.legacy_order_no) {
      this.checkInvoiceSetup(nextProps.order.legacy_order_no);
    }
    return true;
  }*/

  componentDidMount() {
    this.checkInvoiceSetup(this.props.order.legacy_order_no);
  }

  render() {

    var pat = new RegExp("QAD-.*");

    if (pat.test(this.props.order.data_source)) {
      this.state = {
        displayOption: "none"
      };
    }

    if (this.props.hideDownloadAllInvs) {
      this.state = {
        displayOption: "none"
      };
    }
    return (
      <h4 key="InvoicePopupWrapperClass" className="modal-title" style={{ "textAlign": "left"}}>
        <div className="pull-left">{T('Invoice(s)')}&nbsp; {T(this.props.invStatusinPopup)}</div>
        <div className="pull-left">{T('for') + " " + T('Order') + " " + this.props.order.order_no}</div>
        <div id="downloadAllInvs" className="pull-right">
          <button type="button" className="btn btn-danger" style={{display: this.state.displayOption}} onClick={this.props.handleDownloadAllInvs}>
            {T('Download all Invoices')}
          </button>
        </div>
      </h4>
    );
  }
};




//----------------------------------------------------------------------
//   HeaderTabs --
//
//----------------------------------------------------------------------
class HeaderTabs extends React.Component {

  render() {
    var order = this.props.order;

    var myWidgetMode = "external";
    if (this.props.myWidgetMode) {
      myWidgetMode = this.props.myWidgetMode;
    }

    var exceptions = this.props.order.exceptions;
    var additional_info = fmArray(OSWidgetLib.additionalInfo(order.tenant, "ex", "hdr", exceptions, "header", "", "", "", order, 0, order.om_system));

    var orderValueText = fmNum(order.total_price)+' '+order.currency;
    if (order.total_price == null) {
      orderValueText = T('notAuthorized');
    }
    if (order.aaid == 'ihp2b' && order.is_hp2b_partner == 'N'
        && order.trade_model == 'Multichannel STM'
    ) {
        orderValueText = "";
    }

    var sCLabel = DD('contract_no', 'ext_widget'), sCValue = order.contract_no;
    if (order.customer_segment == "Public Sector" && order.om_region == "US" && order.distrib_channel == "20")
      sCLabel = sCValue = "";

    var paymentTermText = order.payment_term_text;
    if (order.aaid == 'ihp2b' && order.is_hp2b_partner == 'N'
        && (order.trade_model == 'DMFi'
            || order.trade_model == 'Multichannel DMFi'
            || order.trade_model == 'Multichannel STM')
    ) {
        paymentTermText = "";
    }

    var labelGridDataOrderDetail = [
          [ DD('customer_name',     'ext_widget')      , order.customer_name,
            DD('quote_no',          'ext_widget')      , order.quote_no,
            DD('total_price',       'ext_widget',  'right')      , orderValueText
          ],

          [ DD('customer_no',       'ext_widget')      , order.customer_no,
            DD('customer_req_date', 'ext_widget')      , fmDate(order.customer_req_date),
            DD('order_type_descr',  'ext_widget',   'right')      , order.order_type_descr
          ],

          [ DD('gvt_contract_number',      'ext_widget')         , order.gvt_contract_number == "" ? order.purch_agree : order.purch_agree + ' / ' + order.gvt_contract_number,
            DD('purch_agent',              'ext_widget')         , order.purch_agent_email,
            DD('payment_terms',            'ext_widget', 'right'), paymentTermText
          ],

          [ DD('agent_id',                    'ext_widget')          , order.agent_id,
            DD('big_deal_id',                 'ext_widget')          , order.big_deal_id,
            'Additional Info',   fmArray(OSWidgetLib.additionalInfo(order.tenant, "ex", "hdr", order.exceptions, "header", "", "", "", order, 0, order.om_system)),
          ],
          [ DD('program_type',                  'ext_widget')         , order.program_type,
            sCLabel                                                   , sCValue,
            DD('end_customer_po_no',           'ext_widget', 'right') , order.end_customer_po_no
          ]
    ];

    var comments = this.props.order.comments;
    if (!comments) comments = [];
    var labelGridDataMoreInfo = [
    ];
    var labelGridDataComments = [];
    for (var i = 0; i < comments.length; i++) {
        if ( comments[i].key == "ShippingInstructions" && order.om_system == "SAP-SCP" && order.originating_system == "HP2B CSR" ) {
          continue;
        }
        labelGridDataComments.push(
          [ comments[i].key == "" ? T('Comment') : comments[i].key ,
            comments[i].value
          ]
        );
    }

    //console.log('order.customer_notes:', order.customer_notes);
    if (order.customer_notes && order.customer_notes != "") {
          var subject = "HP Notes for HP Order: "+order.order_no+"; Purchase Order: "+order.purchase_order_no;
          var body    = "HP Order: "+order.order_no+"; Purchase Order: "+order.purchase_order_no
                      + "%0D%0A"
                      + "%0D%0A"
                      + "HP Notes"
                      + "%0D%0A"
                      + order.customer_notes.replace(/\\n/g,"%0D%0A")
                      + "%0D%0A"
                      + "%0D%0A"
                      + "Last Updated On: " + fmDate(order.customer_notes_lupd)

          var mailLink = "?subject=" + subject + "&body=" + body;

          var hpnotesLabel =
             <span>
                <b><L>HP Notes</L></b>&nbsp;&nbsp;<a href={"mailto:"+mailLink}><b><i className="glyphicon glyphicon-edit"/>&nbsp;Email</b></a>
                <br/>
                <span style={{"fontSize":"11px"}}><L>last updated on </L>{fmDate(order.customer_notes_lupd)}</span>
             </span>

          var s = order.customer_notes.split('\\n');
          if (s.length < 2) {
            labelGridDataComments.unshift( [ hpnotesLabel, order.customer_notes ] );
          } else {
            var lines = [ s[0] ];
            for (var i=1; i<s.length; i++) {
              lines.push( React.createElement("br", null) );
              lines.push( s[i] );
            }
            labelGridDataComments.unshift( [ hpnotesLabel, lines ] );
          }
    }

    var commentsTab = "";

    if (myWidgetMode != 'public' && labelGridDataComments != "") {
      commentsTab =
        <Tab name="commentsTab" label={T('Comments')}>
           <LabelGrid data={labelGridDataComments} />
        </Tab>
      ;
    }

    var datesTab = (
      <Tab name="dates" label={T('Dates')}>
        <Dates order={order} caller='ext_widget' />
      </Tab>
    );

    var casesTab = "";

    if (order.cases && order.cases.length > 0) {
      var casesLabel = (
        <span>
          <L>Cases</L>
          &nbsp;
          <div className="badge badge-red">{order.cases?.length}</div>
        </span>
      );
      var casesList = order.cases.map( function(caseEntry) {
        var CaseViewer3wLink = "";
        if (order.crp && order.crp.baseURL && order.crp.viewCaseEP && caseEntry.case_instance_id)
          CaseViewer3wLink = order.crp.baseURL.replace("_LANGCODE_", getLangCode()) + order.crp.viewCaseEP + caseEntry.case_instance_id;
          return (<tr>
                    <td>
                    {
                      (UserSettings.user_id && UserSettings.user_id.toLowerCase() == caseEntry.case_logged_in_email.toLowerCase()) ||
                      (order.userEmail && order.userEmail.toLowerCase() == caseEntry.case_logged_in_email.toLowerCase())
                        ? (<a href={CaseViewer3wLink} target="_blank">{caseEntry.case_number}</a>)
                        : (caseEntry.case_number)
                    }
                    </td>
                    <td>{caseEntry.case_status_customer}</td>
                    <td>{caseEntry.case_process_name}</td>  
                    <td>{caseEntry.case_category}</td>
                    <td>{caseEntry.case_subcategory}</td>
                    <td>{fmDateTime(caseEntry.case_update_date)}</td>
                    <td>{caseEntry.case_requestor_name}</td>
                    <td>{caseEntry.case_requestor_email}</td>
                  </tr>
                 );   
      });   
      casesTab =
        <Tab name="casesTab" label={casesLabel}>
           <table className="table table-hover">
             <thead>
               <tr>
                 <th><L>Case Number</L></th>
                 <th><L>Status</L></th>
                 <th><L>Case Title</L></th>
                 <th><L>Case Category</L></th>
                 <th><L>Case Subcategory</L></th>
                 <th><L>Updated at</L></th>
                 <th><L>Requestor Name</L></th>
                 <th><L>Requestor Email</L></th>
               </tr>
             </thead>
             <tbody>
               {casesList}
             </tbody>
           </table>
        </Tab>
      ;
    }

    var contactHeader = null;
    var contactDetail = null;

    if (myWidgetMode != 'public') {
        contactHeader = <thead>
                        <tr>
                          <th className="addressPartner" colSpan="5"><L>Contact Information (name, phone, fax, mail)</L></th>
                        </tr>
                        </thead>

        contactDetail = <tbody>
                        <tr>
                          <td>Name: {order.ship_to_attention.name}</td>
                          <td>Name: {order.sold_to_attention.name}</td>
                          <td>Name: {order.invoice_to_attention.name}</td>
                          {fmAddress(order.end_customer) != "" ? (<td>Name: </td>) : ""}
                          {fmAddress(order.reseller_customer) != "" ? (<td>Name: </td>) : ""}
                        </tr>
                        <tr>
                          <td>Phone: {order.ship_to_attention.phone}</td>
                          <td>Phone: {order.sold_to_attention.phone}</td>
                          <td>Phone: {order.invoice_to_attention.phone}</td>
                          {fmAddress(order.end_customer) != "" ? (<td>Phone: {order.end_customer_attention.phone      != "" ? order.end_customer_attention.phone : ""}</td>) : ""}
                          {fmAddress(order.reseller_customer) != "" ? (<td>Phone: {order.reseller_customer_attention.phone != "" ? order.reseller_customer_attention.phone : ""}</td>) : ""}
                       </tr>
                       <tr>
                          <td>Fax: {order.ship_to_attention.fax}</td>
                          <td>Fax: {order.sold_to_attention.fax}</td>
                          <td>Fax: {order.invoice_to_attention.fax}</td>
                          {fmAddress(order.end_customer) != "" ? (<td>Fax: {order.end_customer_attention.fax      != "" ? order.end_customer_attention.fax : ""}</td>) : ""}
                          {fmAddress(order.reseller_customer) != "" ? (<td>Fax: {order.reseller_customer_attention.fax != "" ? order.reseller_customer_attention.fax : ""}</td>) : ""}
                       </tr>
                       <tr>
                          <td>Email: {order.ship_to_attention.email}</td>
                          <td>Email: {order.sold_to_attention.email}</td>
                          <td>Email: {order.invoice_to_attention.email}</td>
                          {fmAddress(order.end_customer) != "" ? (<td>Email: {order.end_customer_attention.email}</td>) : ""}
                          {fmAddress(order.reseller_customer) != "" ? (<td>Email: {order.reseller_customer_attention.email}</td>) : ""}
                       </tr>
                       </tbody>
    }

    var labelGridDataHPContacts = [
      [ DD('acct_hp_contact_email',   'ext_widget'), order.acct_hp_contact_email ? order.acct_hp_contact_email : "",
        DD('acct_regional_aom_email', 'ext_widget'), order.acct_regional_aom_email ? order.acct_regional_aom_email : "",
        DD('acct_sales_email',        'ext_widget'), "" // For now keeping it empty, later can be filled from order.acct_sales_email
      ]
    ];

    var hpContactsTab = <Tab name="hpContactsTab" label={T('HP Contacts')}>
                          <LabelGrid data={labelGridDataHPContacts} />
                        </Tab>

    // Helper function to render tax details inline with address
    var renderInlineTaxDetails = function(taxDetails) {
        if (!taxDetails) {
            return null;
        }
        return (
            <div style={{marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #ddd'}}>
              <div style={{fontSize: '12px', color: '#555', marginBottom: '3px'}}>
                  <strong>Tax ID:</strong> {taxDetails}
              </div>
            </div>
        );
    };

    return (
       <TabBar id="hdrTab" toggle='yes' class='tabbar-toggle tabbar-toggle-up' title='Collapse / Expand Header tabs' style={{"right":"15px"}}>

         <Tab active name="orderDetailTab" label={T('Order Details')}>
           <LabelGrid data={labelGridDataOrderDetail}/>
         </Tab>


         <Tab name="addressTab" label={T('Address')}>

           <table className="table table-hover" id='addressTable'>
            <thead>
            <tr>
               <th className="addressPartner"><DDLabel field={DD('ShipToAddr',    'ext_widget')} /></th>
               <th className="addressPartner"><DDLabel field={DD('SoldToAddr',    'ext_widget')} /></th>
               <th className="addressPartner"><DDLabel field={DD('InvoiceToAddr', 'ext_widget')} /></th>
               {fmAddress(order.end_customer) != "" ? (<th className="addressPartner"><L>End Customer</L></th>): ""}
               {fmAddress(order.reseller_customer) != "" ? (<th className="addressPartner"><L>Reseller</L></th>): ""}
            </tr>
            </thead>
            <tbody>
            <tr>
               <td>
                 <div>
                   {fmAddress(order.ship_to_addr)}
                   {renderInlineTaxDetails(order.ship_to_tax_id)}
                 </div>
               </td>
               <td>
                 <div>
                   {fmAddress(order.sold_to_addr)}
                   {renderInlineTaxDetails(order.sold_to_tax_id)}
                 </div>
               </td>
               <td>
                 <div>
                   {fmAddress(order.invoice_to_addr)}
                   {renderInlineTaxDetails(order.inv_to_tax_id)}
                 </div>
               </td>
               {fmAddress(order.end_customer) != "" ? (<td>{fmAddress(order.end_customer)}</td>) : ""}
               {fmAddress(order.reseller_customer) != "" ? (<td>{fmAddress(order.reseller_customer)}</td>) : ""}
            </tr>
            </tbody>
            {contactHeader}
            {contactDetail}
           </table>

        </Tab>

       {commentsTab}
       {casesTab}
       {datesTab}
       {hpContactsTab}

       </TabBar>
    )
  }
};


//----------------------------------------------------------------------
//   ItemTabs -- item/bundle by open/shipped/canceled items
//
//----------------------------------------------------------------------
class ItemTabs extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      itemCat: 'all',
      render: {
        service: false,
        shipToAddr: false
      },
      crpItems: []
    }

    this.handleSelectColumn  = this.handleSelectColumn.bind(this);
    this.handleCRPItems      = this.handleCRPItems.bind(this);

    this.MAX_CRP_ITEMS = (this.props.order.tenant == 'HPICS') ? 1 : 25;

    this.crpBtnRefs = [];
  }

  handleSelectColumn(e) {
    if(this.state.itemCat != e.target.value ) {
      this.setState({
        itemCat: e.target.value,
      })
    }
    e.preventDefault();
  }

  handleCRPItems(item) {
    var crpItems = [...this.state.crpItems]

    if (crpItems.includes(item)) {
      crpItems.splice(crpItems.indexOf(item), 1)

    } else {
      if (crpItems.length < this.MAX_CRP_ITEMS) {
        crpItems.push(item);

      } else {
        toast.info("Maximum number of items that can be selected is " + this.MAX_CRP_ITEMS);
        return;
      }
    }

    this.setState({crpItems: crpItems});
    this.props.updateCRPItems([...crpItems]);
  }

  render() {


    var order = this.props.order;
    var items = this.props.order.items;
    var item_subitem = this.props.item_subitem;
    var render = this.state.render;

    var checkProforma = 0;
    var countProforma = 0;

      if (items.length) {
        if (order.om_region == "APJ") {
          for (var i = 0; i < items.length; i++) {
            if (items[i].proforma_invoice_no) {
              countProforma++;
              break;
            }
          }
        }
      }

    if (!items) items = [];

    var groups = {};
    var counts = {};
    var hlitems = {};
    var itemTab = "";
    var param   = "";
    var sItems   = [];
    var sCounts  = 0;
    var shipToAddressTab = "" ;
    var multiShipTo      = OSWidgetLib.ZMSOOrder(this.props.order);
    var somOrder         = OSWidgetLib.SOMOrder(this.props.order);
    var fieldExist       = OSWidgetLib.checkFieldValueExist(this.props.order.items,['canceled_at','cust_product_no','prod_localization','shipment_no','ship_cancelled_at','fcdn','ro_etrans_scope','workflow_status']);

    if (this.props.b2bparameters && this.props.b2bparameters != "") {                                   
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }

    var sStyle = {  display : "inline-block" ,
                    outline : 'none' ,
                    fontSize: "12px" ,
                    width   : "fit-content" ,
                    height  : "fit-content",
                    color   : "#555",
                    border  : "1px solid #ccc",
                    margin  : "0 10px",
                    borderRadius   : "3px",
                    backgroundColor: "#fff",
                  }


    var itemCatBox =  <select name="itemOptions"  onClick={this.handleSelectColumn} style={sStyle}>
                        <option value="all">All</option>
                        <option value="openItems">Open</option>
                        <option value="shippedItems">Shipped</option>
                        <option value="canceledItems">Canceled</option>
                      </select>

    if(multiShipTo) {
      var groupCounts = {};
      OSWidgetLib.PrepareActiveItemGroupsForZMSO( this.props.order.items, groups, counts, groupCounts);

      if ( this.state.itemCat == "all"           )  { sItems = groups.allStati   ; sCounts = groupCounts.allStati  ;}
      if ( this.state.itemCat == "openItems"     )  { sItems = groups.open       ; sCounts = groupCounts.open      ;}
      if ( this.state.itemCat == "shippedItems"  )  { sItems = groups.shipped    ; sCounts = groupCounts.shipped   ;}
      if ( this.state.itemCat == "canceledItems" )  { sItems = groups.canceled   ; sCounts = groupCounts.canceled  ;}

      var zmsoItems = {
        header: [
          { name: DD('item_subitem',      'ext_widget') },
          { name: DD('material_no',       'ext_widget') , nowrap:1 },
          { name: DD('cust_product_no',   'ext_widget') },
          { name: DD('prod_localization', 'ext_widget') },
          { name: DD('product_descr',     'ext_widget') },
          { name: DD('status',            'ext_widget') },
          { name: DD('so_line_item_qty',  'ext_widget') ,  right:1 },
          { name: DD('sched_line_qty',    'ext_widget') ,  right:1 },
          { name: DD('bundle_price',      'ext_widget') ,  right:1 },
          { name: 'MOT' },

          { name: DD('shipment_no',       'ext_widget' ) },
          { name: DD('sched_ship_date',   'ext_widget') ,  right:1 },
          { name: DD('eshp_actual',       'ext_widget') ,  right:1 },
          { name: DD('customer_req_date', 'ext_widget', 'right' ) },
          { name: DD('sched_delv_date',   'ext_widget','right') ,  right:1 },
          { name: DD('ship_cancelled_at', 'ext_widget','right') ,  right:1 },
          { name: DD('pod_at',                      'ext_widget','right'),  right:1 },

          { name: DD('endcust_planned_delivery_date', 'ext_widget','right'), nowrap:1 },
          { name: DD('endcust_delivery_date',         'ext_widget','right'), nowrap:1 },

          { name: DD('invoice_no',           'ext_widget','right' ) },
          { name: DD('proforma_invoice_no',  'ext_widget','right') },
          { name: DD('proforma_invoice_import_no',  'ext_widget','right') },

          { name: DD('canceled_at',         'ext_widget', 'right' ) },
          { name: DD('cancellation_reason', 'ext_widget', 'right' ) },

          { name: 'Additional Info'        },

        ],
        data: OSWidgetLib.constructRowsWrapper( sItems,true, function(row) {
          var proInvUrl = "",proInvCell = "",proInvImpUrl = "",proInvImpCell = "";
          if ( order.with_prices == "N" ) {
            var inv_cell = row.invoice_no;
          } else {
            if(window.extMobileMode) {
              var inv_url  =  RewriteRESTURL("/os/ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.invoice_no+"&data_source="+row.system + param);
              var inv_cell =  <a href= {inv_url} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                                {row.invoice_no}
                              </a>;
              if( order.om_region == "APJ" ) {
                proInvUrl = RewriteRESTURL("/os/ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.proforma_invoice_no+"&data_source="+row.system + param);
                proInvCell = <a href= {proInvUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                                {row.proforma_invoice_no}
                              </a>;

                proInvImpUrl = RewriteRESTURL("/os/ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.proforma_invoice_import_no+"&data_source="+row.system + param);
                proInvImpCell = <a href= {proInvImpUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                                {row.proforma_invoice_import_no}
                              </a>;
              }
            } else {
              var inv_url  =  RewriteRESTURL("ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.invoice_no+"&data_source="+row.system + param);
              var inv_cell =  <a href= {inv_url} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                                {row.invoice_no}
                              </a>;
              if( order.om_region == "APJ" ) {
                proInvUrl = RewriteRESTURL("ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.proforma_invoice_no+"&data_source="+row.system + param);
                proInvCell = <a href= {proInvUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                                {row.proforma_invoice_no}
                              </a>;
                proInvImpUrl = RewriteRESTURL("ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.proforma_invoice_import_no+"&data_source="+row.system + param);
                proInvImpCell = <a href= {proInvImpUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                                {row.proforma_invoice_import_no}
                              </a>;
              }
            }
            // CR 15559 - deactivate invoice link for QAD
            if ( row.system == "QAD-IL" || row.system == "QAD-JP" || row.system == "QAD-NL" ||  row.system == "QAD-US"
               || (order.aaid == "ihp2b" && order.is_hp2b_partner == 'N' && (order.trade_model == "DMFi" || order.trade_model == "Multichannel DMFi" || order.trade_model == "Multichannel STM"))
            ) {
              inv_cell   = row.invoice_no;
              proInvCell = row.proforma_invoice_no;
              proInvImpCell = row.proforma_invoice_import_no;
            }
            if ( order.aaid == "ihp2b" && order.is_hp2b_partner == 'N' && order.trade_model == "Multichannel STM" ) {
              row.bundle_price = ""
            }
          }
          var isCanceledStatusOnItem = ((row.status || "").toUpperCase() == "CANCELED" || (row.status || "").toUpperCase() == "CANCELLED");
          var additional_info = [];
          if (!isCanceledStatusOnItem) {
            additional_info = fmArray(OSWidgetLib.additionalInfo(order.tenant, "ex", "item", row.exceptions, "", row.delivery_status, "", "", order, "", row.system, OSWidgetLib.mapItemStatus(row.status, order.tenant)));
          }

          // Submit Request button at item level (3W CRP Integration)
          var sRBtn = OSWidgetLib.genItemLevelSubReqBtnExt(UserSettings, order, row, this, this.state.crpItems)
          var itemObj = <span>{sRBtn}{row.item_subitem}</span>

          var arr = [
            itemObj,
            row.material_no,
            row.cust_product_no,
            row.prod_localization,
            row.product_descr,
            OSWidgetLib.mapItemStatus(row.status, order.tenant),
            row.so_line_item_qty,
            row.sched_line_qty,
            window.mobileMode ? 'N/A' : fmNum(row.bundle_price),
            row.transportmode_act ? row.transportmode_act : row.transportmode_orig,
            row.shipment_no,
            fmDate(row.sched_ship_date),
            fmDate(row.eshp_actual),
            fmDate(row.customer_req_date),
            fmDate(row.sched_delv_date),
            fmDate(row.ship_cancelled_at),
            fmDate(row.pod_at),

            fmDate(order.endcust_planned_delivery_date),
            fmDate(order.endcust_delivery_date),

            inv_cell,
            proInvCell,
            proInvImpCell,

            fmDate(row.canceled_at),
            row.cancellation_reason_sap,

            additional_info,
          ]


          !fieldExist['canceled_at'] && arr.splice(22,2);

          if(order.om_region != "APJ" || !countProforma){
           arr.splice(20,1);
           checkProforma = 1;
          }
          if (["DMFi", "Multichannel DMFi", "Multichannel STM"].indexOf(order.trade_model) < 0) {
            arr.splice(17,2);
          }

          !fieldExist['ship_cancelled_at']  && arr.splice(15,1);
          !fieldExist['shipment_no']        && arr.splice(10,1);
          order.trade_model == "DMFi"       && arr.splice(8, 0, window.mobileMode ? 'N/A' : fmNum(row.net_unit_price));
          !fieldExist['prod_localization']  && arr.splice(3,1);
          !fieldExist['cust_product_no']    && arr.splice(2,1);

          return arr;
        }.bind(this))
      }

      !fieldExist['canceled_at']        && zmsoItems.header.splice(22,2);

      if (checkProforma || !zmsoItems.data.length) {
       zmsoItems.header.splice(20,1);
      }

      if (["DMFi", "Multichannel DMFi", "Multichannel STM"].indexOf(order.trade_model) < 0) {
        zmsoItems.header.splice(17,2);
      }

      !fieldExist['ship_cancelled_at']  && zmsoItems.header.splice(15,1);
      !fieldExist['shipment_no']        && zmsoItems.header.splice(10,1);
      order.trade_model == "DMFi"       && zmsoItems.header.splice(8, 0, { name: DD('net_unit_price', 'ext_widget'), right:1 });
      !fieldExist['prod_localization']  && zmsoItems.header.splice(3,1);
      !fieldExist['cust_product_no']    && zmsoItems.header.splice(2,1);

      var zmsoLabel = (
                        <span>
                          <L>Items</L>
                          <div className="badge badge-grey">{sCounts}</div>
                          &nbsp;{itemCatBox}
                        </span>
                      );


      itemTab = <Tab active name="zmsoItemsTab" label={zmsoLabel}>
                  <SimpleDataGrid header={zmsoItems.header}
                                  data={zmsoItems.data}
                                  doUpdate={true}
                                  wrapper='zmso'
                                  caller="ext"
                                  enableDownload={true}
                                  myWidgetMode={this.props.myWidgetMode}
                                  order={this.props.order}/>
                </Tab>

      shipToAddressTab = <Tab name="shipToAddressTab" label="shipToAddress" onClick={()=>this.setState(prevState=>({render:{...prevState.render, shipToAddr: true}}))}>
                           { this.state.render.shipToAddr && <ShipToAddress order={order} simpleWidget={true} doUpdate={true} expandedByDefault={window.extMobileMode} caller="ext"/> }
                         </Tab>
    } else {
      if(somOrder) {
        OSWidgetLib.PrepareItemGroupsForSOM( items, groups, counts);
      } else {
        hlitems = OSWidgetLib.RemoveBom3Bom5LowerLevel(items);
        OSWidgetLib.PrepareItemGroups( hlitems, groups, counts);
      }

      if ( this.state.itemCat == "all"           )  { sItems = groups.eOdmItems  ; sCounts = counts.eOdmItems ;}
      if ( this.state.itemCat == "openItems"     )  { sItems = groups.open       ; sCounts = counts.open      ;}
      if ( this.state.itemCat == "shippedItems"  )  { sItems = groups.shipped    ; sCounts = counts.shipped   ;}
      if ( this.state.itemCat == "canceledItems" )  { sItems = groups.canceled   ; sCounts = counts.canceled  ;}

      checkProforma = 0;

      var mergedItems = {
        header: [
          { name: DD('item_subitem',      'ext_widget') },
          { name: DD('material_no',       'ext_widget') , nowrap:1 },
          { name: DD('cust_product_no',   'ext_widget') },
          { name: DD('prod_localization', 'ext_widget') },
          { name: DD('product_descr',     'ext_widget') },
          { name: DD('status',            'ext_widget') },
          { name: DD('so_line_item_qty',  'ext_widget') ,  right:1 },
          { name: DD('sched_line_qty',    'ext_widget') ,  right:1 },
          { name: DD('bundle_price',      'ext_widget') ,  right:1 },
          { name: 'MOT' },

          { name: DD('shipment_no',       'ext_widget' ) },
          { name: DD('sched_ship_date',   'ext_widget') ,  right:1 },
          { name: DD('eshp_actual',       'ext_widget') ,  right:1 },
          { name: DD('customer_req_date', 'ext_widget', 'right' ) },
          { name: DD('sched_delv_date',   'ext_widget','right') ,  right:1 },
          { name: DD('ship_cancelled_at', 'ext_widget','right') ,  right:1 },
          { name: DD('pod_at',                      'ext_widget','right'),  right:1 },

          { name: DD('endcust_planned_delivery_date', 'ext_widget','right'), nowrap:1 },
          { name: DD('endcust_delivery_date',         'ext_widget','right'), nowrap:1 },

          { name: DD('invoice_no',           'ext_widget','right' ) },
          { name: DD('proforma_invoice_no',  'ext_widget','right') },
          { name: DD('proforma_invoice_import_no',  'ext_widget','right') },

          { name: DD('canceled_at',         'ext_widget', 'right' ) },
          { name: DD('cancellation_reason', 'ext_widget', 'right' ) },

          { name: 'Additional Info'        },
          { name: DD('fcdn',                'ext_widget', 'right' ) },

        ],
        data: OSWidgetLib.constructRows( sItems, function(row) {
          var proInvUrl = "",proInvCell = "",proInvImpUrl = "",proInvImpCell = "";
          if ( order.with_prices == "N" ) {
            var inv_cell = row.invoice_no;
          } else {
            if(window.extMobileMode) {
              var inv_url  =  RewriteRESTURL("/os/ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.invoice_no+"&data_source="+row.system + param);
              var inv_cell =  <a href= {inv_url} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                                {row.invoice_no}
                              </a>;
              if( order.om_region == "APJ" ) {
                proInvUrl = RewriteRESTURL("/os/ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.proforma_invoice_no+"&data_source="+row.system + param);
                proInvCell = <a href= {proInvUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                                {row.proforma_invoice_no}
                              </a>;
                proInvImpUrl = RewriteRESTURL("/os/ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.proforma_invoice_import_no+"&data_source="+row.system + param);
                proInvImpCell = <a href= {proInvImpUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                                {row.proforma_invoice_import_no}
                              </a>;
              }
            } else {
              var inv_url  =  RewriteRESTURL("ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.invoice_no+"&data_source="+row.system + param);
              var inv_cell =  <a href= {inv_url} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                                {row.invoice_no}
                              </a>;
              if( order.om_region == "APJ" ) {
                proInvUrl = RewriteRESTURL("ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.proforma_invoice_no+"&data_source="+row.system + param);
                proInvCell = <a href= {proInvUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                                {row.proforma_invoice_no}
                              </a>;
                proInvImpUrl = RewriteRESTURL("ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.proforma_invoice_import_no+"&data_source="+row.system + param);
                proInvImpCell = <a href= {proInvImpUrl} target="_blank" style={{"float":"left", "cursor": "pointer", "color": "#0096d6"}}>
                                {row.proforma_invoice_import_no}
                              </a>;
              }
            }
            // CR 15559 - deactivate invoice link for QAD
            if ( row.system == "QAD-IL" || row.system == "QAD-JP" || row.system == "QAD-NL" ||  row.system == "QAD-US"
               || (order.aaid == "ihp2b" && order.is_hp2b_partner == 'N' && (order.trade_model == "DMFi" || order.trade_model == "Multichannel DMFi" || order.trade_model == "Multichannel STM"))
            ) {
              inv_cell   = row.invoice_no;
              proInvCell = row.proforma_invoice_no;
              proInvImpCell = row.proforma_invoice_import_no;
            }
            if ( order.aaid == "ihp2b" && order.is_hp2b_partner == 'N' && order.trade_model == "Multichannel STM" ) {
              row.bundle_price = ""
            }
          }
          var isCanceledStatusOnItem = ((row.status || "").toUpperCase() == "CANCELED" || (row.status || "").toUpperCase() == "CANCELLED");
          var additional_info = [];
          if (!isCanceledStatusOnItem) {
            additional_info = fmArray(OSWidgetLib.additionalInfo(order.tenant, "ex", "item", row.exceptions, "", row.delivery_status, "", "", order, "", row.system, OSWidgetLib.mapItemStatus(row.status, order.tenant)));
          }

          // Submit Request button at item level (3W CRP Integration)
          var sRBtn = OSWidgetLib.genItemLevelSubReqBtnExt(UserSettings, order, row, this, this.state.crpItems)
          var itemObj = <span>{sRBtn}{row.item_subitem}</span>

          var arr = [
            itemObj,
            row.material_no,
            row.cust_product_no,
            row.prod_localization,
            row.product_descr,
            OSWidgetLib.mapItemStatus(row.status, order.tenant),
            row.so_line_item_qty,
            row.sched_line_qty,
            window.mobileMode ? 'N/A' : fmNum(row.bundle_price),
            row.transportmode_act ? row.transportmode_act : row.transportmode_orig,
            row.shipment_no,
            fmDate(row.sched_ship_date),
            fmDate(row.eshp_actual),
            fmDate(row.customer_req_date),
            fmDate(row.sched_delv_date),
            fmDate(row.ship_cancelled_at),
            fmDate(row.pod_at),

            fmDate(order.endcust_planned_delivery_date),
            fmDate(order.endcust_delivery_date),

            inv_cell,
            proInvCell,
            proInvImpCell,

            fmDate(row.canceled_at),
            row.cancellation_reason_sap,

            additional_info,
            (order.ro_etrans_scope === 'Y') ?
              (row.fcdn ? <span title={OSWidgetLib.getFcdnStatusText(row.workflow_status)}>{row.fcdn}</span> : '') : null,
          ]

          // Conditionally remove FCDN column if ro_etrans_scope is not 'Y'
          if (order.ro_etrans_scope != 'Y') {
            arr.splice(arr.length - 1, 1);
          }

          !fieldExist['canceled_at']        && arr.splice(22,2);

          if(order.om_region != "APJ" || !countProforma){
           arr.splice(20,1);
           checkProforma = 1;
          }
          if (["DMFi", "Multichannel DMFi", "Multichannel STM"].indexOf(order.trade_model) < 0) {
            arr.splice(17,2);
          }

          !fieldExist['ship_cancelled_at']  && arr.splice(15,1);
          !fieldExist['shipment_no']        && arr.splice(10,1);
          order.trade_model == "DMFi"       && arr.splice(8, 0, window.mobileMode ? 'N/A' : fmNum(row.net_unit_price));
          !fieldExist['prod_localization']  && arr.splice(3,1);
          !fieldExist['cust_product_no']    && arr.splice(2,1);

          return arr;
        }.bind(this))
      }

      // Conditionally remove FCDN header if not applicable
      if (order.ro_etrans_scope !== 'Y') {
        mergedItems.header.splice(mergedItems.header.length - 1, 1);
        mergedItems.data = mergedItems.data.map(function(row) {
          if (row.length > 0 && row[row.length - 1] === '') {
            return row.slice(0, -1);
          }
          return row;
        });
      }

      !fieldExist['canceled_at']   && mergedItems.header.splice(22,2);

      if (checkProforma || !mergedItems.data.length) {
       mergedItems.header.splice(20,1);
      }

      if (["DMFi", "Multichannel DMFi", "Multichannel STM"].indexOf(order.trade_model) < 0) {
        mergedItems.header.splice(17,2);
      }

      !fieldExist['ship_cancelled_at']  && mergedItems.header.splice(15,1);
      !fieldExist['shipment_no']        && mergedItems.header.splice(10,1);
      order.trade_model == "DMFi"       && mergedItems.header.splice(8, 0, { name: DD('net_unit_price', 'ext_widget'), right:1 });
      !fieldExist['prod_localization']  && mergedItems.header.splice(3,1);
      !fieldExist['cust_product_no']    && mergedItems.header.splice(2,1);

      var mLabel = (<span>
                          <L>Items</L>
                          <div className="badge badge-grey">{sCounts}</div>
                          &nbsp;{itemCatBox}
                        </span>
                    );


      itemTab = <Tab active name="mergedItemsTab" label={mLabel}>
                  <SimpleDataGrid header={mergedItems.header} data={mergedItems.data} item_subitem={item_subitem} doUpdate={true} order={this.props.order} expandedByDefault={window.extMobileMode}/>
                </Tab>
    }

    var myWidgetMode = "external";
    if (this.props.myWidgetMode) {
      myWidgetMode = this.props.myWidgetMode;
    }

    var mfgDataText = null;
    var mfgDataURL = null;
    var mfgDataStyle = {"color":"#767676", "cursor":"default", "textDecoration":"none"}

    if ((typeof WidgetMode !== 'undefined' && (WidgetMode == 'onetime') || myWidgetMode == 'public')) {
        mfgDataText = T("Sensitive information – please login via the HP portal to view this!");
    }

    if ((this.props.order.nr_of_serials && this.props.order.nr_of_serials > 0 && mfgDataText == null) || (this.props.order.nr_of_trackids && this.props.order.nr_of_trackids > 0 && mfgDataText == null)) {
      mfgDataStyle = {"color":"#0096d6", "cursor":"pointer", "textDecoration":"none"}
      mfgDataURL = RewriteRESTURL("/os/ossui/v1/ex/exportMFGDataToExcelTitanium/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale);

      if (this.props.b2bparameters && this.props.b2bparameters != "") {
        mfgDataURL = "/os/ossui/v1/ex/exportMFGDataToExcelTitanium/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale
        + '?b2bparameters=' + encodeURIComponent( this.props.b2bparameters);
      }

      if (sfdcSession) {
        mfgDataURL = "/os/ossui/v1/ex/exportMFGDataToExcelTitanium/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale
        + "?sfdcSession="+ sfdcSession;
      }
    }

    var mfgData = (
      <>
        <span style={{"float":"right"}}>
          <a href={mfgDataURL} target="_self" title={mfgDataText} style={mfgDataStyle}>
            <i className="glyphicon glyphicon-circle-arrow-down" style={{"top" : "2px"}}/>&nbsp;Download Mfg Data
          </a>
        </span>
      </>
    )

    //count relevant items for the amount ribbon, only show service tab when there are NK (poly-) items
    //todo polyitems OR carepack
    var hasPolyItems = OSWidgetLib.PolyServiceOrder(this.props.order);
    var isCarepackOrder = false;
    var MCCBundleChildItemsNum = 0;
    var carepackItemsNum = 0;

    for (var i=0; i < this.props.order.items.length; i++) {
      //if all items are MCCBundle-Childs, dont show 
      if (items[i].carepack_item == "Y" && items[i].higher_level == 0) {
        isCarepackOrder = true;
        break;
      }
      if (items[i].carepack_item == "Y" && items[i].higher_level != 0) {
        carepackItemsNum++;
      }
      if (items[i].carepack_item == "Y" && items[i].bundle_type == "MCCBundle-Child" ) {
        MCCBundleChildItemsNum++;
      }

    }
    if (MCCBundleChildItemsNum != carepackItemsNum && this.props.order.carepack_flag == 'Y') {
      isCarepackOrder = true;
    }

    var servicesTab = <Tab name="servicesTab" label={T('Services')} onClick={()=>this.setState(prevState=>({render:{...prevState.render, service: true}, commitBtnPressed: false}))} >
                        {render.service && <Services order={this.props.order} caller="ext_widget"/>}
                      </Tab>

    const shouldRenderServicesTab = isCarepackOrder || hasPolyItems;

    return (
      <>
      {mfgData}
      <TabBar id="itemsTab">
        {itemTab}
        {shouldRenderServicesTab && servicesTab}
        {shipToAddressTab}
      </TabBar>
     </>
    )
  }
};


//----------------------------------------------------------------------
//  DetailedOrderStatus   --  the complete widget
//                            showing timeline + header + item + ...
//
//----------------------------------------------------------------------
export class DetailedOrderStatus extends React.Component {

  constructor(props) {
    super(props);
    if (this.props.order.tenant == "HPICS" && isAdvancedExchangeServiceType(this.props.order.service_type)) {
        this.state = {
          activeItemButtons: {
            processing: false,
            shippedToCustomer : false, 
            awaitingReturn: false,
            repairInProgress: false,
            repairComplete: false,
            received: false,
            canceled : false
          },
          generalUser: true
        };  

      } else if (this.props.order.order_type && this.props.order.order_type.startsWith('SOM-')) {
        this.state = {
          activeItemButtons: {
            submitted: false,
            pending: false,
            active: false,
            planned: false,
            canceled: false,
            expired: false
          },
          generalUser: true
        };

      } else {
        this.state = {
          activeItemButtons: {
            submitted: false,
            accepted: false,
            production: false,
            shipmentScheduled: false,
            consolidation: false,
            shippedToCustomer : false, 
            delivered: false,
            received: false,
            canceled : false
          },
          generalUser: true
        };  
      }

      this.handleActiveItemsToggle     = this.handleActiveItemsToggle.bind(this);
  }

  handleActiveItemsToggle(dataId){
      var selButtons = {...this.state.activeItemButtons} 
      selButtons[dataId] = selButtons[dataId] ? false : true;
      this.setState({ activeItemButtons : selButtons });
  }

  render() {

    var myWidgetMode = "external";
    if (this.props.myWidgetMode) {
      myWidgetMode = this.props.myWidgetMode;
    }

    var item_subitem = this.props.item_subitem;

    var groups = {};
    var counts = {};
    var groupCounts = {};
    var zmsoOrder = OSWidgetLib.ZMSOOrder(this.props.order);
    var somOrder  = OSWidgetLib.SOMOrder(this.props.order);
    if (this.props.order.tenant == "HPICS" && isAdvancedExchangeServiceType(this.props.order.service_type)) {
      OSWidgetLib.PrepareActiveItemGroups_CSAdvExch( this.props.order.items, groups, counts, groupCounts);
    } else if(somOrder) {
      OSWidgetLib.PrepareActiveItemGroupsForSOM( this.props.order.items, groups, counts, groupCounts);
    } else if(zmsoOrder) {
      OSWidgetLib.PrepareActiveItemGroupsForZMSO( this.props.order.items, groups, counts, groupCounts);
    } else if(this.props.order.order_type === 'ORDCHG') {
      OSWidgetLib.PrepareActiveItemGroupsForORDCHG( this.props.order.items, groups, counts, groupCounts);
    } else {
      OSWidgetLib.PrepareActiveItemGroups( this.props.order.items, groups, counts, groupCounts);
    }
    var itemGroups = {
      groups: groups,
      counts: counts,
      groupCounts: groupCounts,
    }

    let statusBlock = null;
    if (window.extMobileMode) {
      statusBlock = <>
        <TopStatusSection myWidgetMode={myWidgetMode} order={this.props.order} sfdcSignedRequest={this.props.sfdcSignedRequest} b2bparameters={this.props.b2bparameters} />
        {this.props.order.tenant != 'HPICS' && (
          <Timeline order={this.props.order} />)
        }
      </>
    } else {
      statusBlock = <>
        <div className="statusBox-left">
          <StatusGraphic order={this.props.order} itemGroupsCount={itemGroups.groupCounts} activeItemsToggle={this.handleActiveItemsToggle} activeItemButtons={this.state.activeItemButtons} tenant={UserSettings.tenant} />
        </div>
        <div className="statusBox-right">
          <div className="statusBox-buttons">
            <OswiActions myWidgetMode={myWidgetMode} order={this.props.order} generalUser={this.state.generalUser} userSettings={UserSettings} crpItems={this.props.crpItems} />
          </div>
          {this.props.order.tenant != 'HPICS' &&
            (<div className="statusBox-icons">
              <StatusIcons myWidgetMode={myWidgetMode} order={this.props.order} sfdcSignedRequest={this.props.sfdcSignedRequest} b2bparameters={this.props.b2bparameters} />
            </div>)
          }
        </div>
      </>
    }

    return (

    <div>
      <div id="errorPane" style={{ display: "none", position: "relative" }}>
        <div id="errorPaneText" className="alert alert-danger errorPaneWidget"
             role="alert">
          error text
        </div>
      </div>
      <ToastContainer position='bottom-right' />
      <div id="statusBox" className="statusBox-container" style={{"minHeight": "100px"}}>
        {statusBlock}
      </div>
      <br/>
      <HeaderTabs order={this.props.order} myWidgetMode={myWidgetMode} />
      <br/><br/>
      <ItemTabs order={this.props.order} item_subitem={item_subitem} myWidgetMode={myWidgetMode} b2bparameters={this.props.b2bparameters} updateCRPItems={this.props.updateCRPItems} />
    </div>
  )}
};


//----------------------------------------------------------------------
//  OrderSelectList   --  list for selecting an order
//                        in case multiple orders match filter
//
//----------------------------------------------------------------------
class OrderSelectList extends React.Component {

  render() {

    var order  = this.props.order;
    var self = this;

    var isSFDC = false;

    if (typeof Params === 'undefined') {

      var params = {};

      if (typeof signedRequest != "undefined") {
        isSFDC = true;
        params = {
            callingSystem: 'sfdc',
            lookupType   : 'legacy_order_no',
            signedRequest: signedRequest          
        }
      }

    } else {
      var params = Params;
    }

    //console.log('JOLO: sfdcSession?:', sfdcSession);
    if (sfdcSession) {
      params.sfdcSession = sfdcSession;
      isSFDC = true;
    }

    params.lookupType = 'legacy_order_no';

    if (this.props.b2bparameters) {
      params = {
          lookupType   : 'legacy_order_no',
          lookupValue  : '',
          b2bparameters: this.props.b2bparameters          
      }
    }

    var orders = {
      header: [
        { name: T('HP Order'                 ) },
        { name: T('Purchase Order Date'      ) },
        { name: T('Customer Purchase Order'  ) },
        { name: T('Order Type'               ), width: "60%" }
      ],
      data: order.map( function(row) {
              if (isSFDC) {
                return [
                  <a href={"javascript:showOrderDetail('"+row.legacy_order_no+"')"}>{row.order_no}</a>,
                  fmDate(row.purch_order_date),
                  row.purchase_order_no,
                  row.order_type_descr
                ]
              } else {
                params.lookupValue = row.legacy_order_no;
                var url = '?' + constructURL(params);
                return [
                  <a href={url}>{row.order_no}</a>,
                  fmDate(row.purch_order_date),
                  row.purchase_order_no,
                  row.order_type_descr
                ]
              }
            })
    }

    return (
      <div>
        <div id="errorPane" style={{ display: "none", position: "relative" }}>
          <div id="errorPaneText" className="alert alert-danger errorPaneWidget"
               role="alert">
            error text
          </div>
        </div>
        <SimpleDataGrid header={orders.header} data={orders.data.sort()}/>
      </div>
    );
  }
};


export class SpinningIcon extends React.Component {
  render() {
    return (
      <Loading size='XS' />
    );
  }
};

//----------------------------------------------------------------------
//   ShowOrderWidget
//
//----------------------------------------------------------------------
window.ShowOrderWidget = function(legacy_order_no, item_subitem) {
  var Params = {
      lookupType: "legacy_order_no",
      lookupValue: legacy_order_no,
      callingSystem: 'landingPage'
  }

  ReactDOM.render(
    <ModalWidgetWaiting
      size={"large"}/>
    , document.getElementById('externalWidget')
  );

  $('#ossOrderModal').modal({
      backdrop: 'static'
  });

  GET("/os/ossui/v1/ex/widget/order", Params,
      function(resp) {
          //console.log(resp);
          if (resp.status == 'N') {
              alert(resp.message);
          } else {
              //console.log(resp.data);
              // now show everything
              $('#ossOrderModal').modal('hide');
              ReactDOM.render(
                <OSWidget
                  quickSearchResp={null} order={resp.data} searchVal={null} item_subitem={item_subitem} />
                , document.getElementById('externalWidget')
              );
              $('#ossOrderModal').modal({
                  backdrop: 'static'
              });
          }
      }
  );
}



//----------------------------------------------------------------------
//   SearchResult -- shows search mask
//
//----------------------------------------------------------------------
export class SearchResult extends React.Component {

  handleClick(legacy_order_no) {
    ShowOrderWidget(legacy_order_no);
  }

  render() {
    var order = this.props.data;
    var type  = this.props.type;
    var customer_notes = '';
    if (order.customer_notes) {
      var s = order.customer_notes.split('\\n');
      if (s.length <= 2) {
        customer_notes = order.customer_notes;
      } else {
        var lines = [ s[0] ];
        for (var i=1; i<s.length; i++) {
          lines.push( React.createElement("br", null) );
          lines.push( s[i] );
        }
        customer_notes = lines;
      }
    }
    if (this.props.searchBy == "D") {
      return (
        <tr>
          <td><a onClick={this.handleClick.bind(null,order.legacy_order_no)} style={{ "cursor": "pointer" }}>{order.order_no}</a></td>
          <td>{order.purchase_order_no}</td>
          <td>{fmDate(order.purch_order_date)}</td>
          <td>{order.item_no}</td>
          <td>{order.product_no}</td>
          <td>{OSWidgetLib.mapItemStatus(order.status, order.tenant)}</td>
          <td>{order.serial_no}</td>
        </tr>
      )
    } else {
      return (
        <tr>
          <td><a onClick={this.handleClick.bind(null,order.legacy_order_no)} style={{ "cursor": "pointer" }}>{order.order_no}</a></td>
          <td>{order.purchase_order_no}</td>
          <td>{fmDate(order.purch_order_date)}</td>
          <td>{order.quote_no}</td>
          <td>{OSWidgetLib.mapItemStatus(order.order_overall_status, order.tenant)}</td>
          <td>{order.ship_to_addr_1}</td>
          <td>{order.ship_to_attn}</td>
          <td>{customer_notes}</td>
        </tr>
      )
    }
  }
};

//----------------------------------------------------------------------
//  Download Component For DMFI
//
//----------------------------------------------------------------------

class QuoteDownload extends React.Component {
  constructor(props) {
   super(props);
  }

  render() {
    if(this.props.user == 'Partner'){
      return (
        <a title='download Quote' href={"/os/ossui/v1/ex/quotePartner/download?legacyNo=" + this.props.legacyNo }><button className="btn btn-primary"><i className="glyphicon glyphicon-circle-arrow-down"/>&nbsp;DMFI Quote</button></a>
      );
    } else{
      return (
        <a title='download Quote' href={"/os/ossui/v1/ex/customerLPO/download?legacyNo=" + this.props.legacyNo }><button className="btn btn-primary"><i className="glyphicon glyphicon-circle-arrow-down"/>&nbsp;Customer LPO</button></a>
      );
    }
  }
}

//----------------------------------------------------------------------
//  Upload Component For DMFI
//
//----------------------------------------------------------------------

class QuoteUpload extends React.Component {

  constructor(props) {
	  super(props);

    this.onFileChange = this.onFileChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      file: '',
      loaded: 0,
      textStyle: {}
    } 
  }

  onFileChange(e) {
    this.setState({ file: e.target.files[0], loaded:0 })
  }

  async onSubmit(e) {
    e.preventDefault();
    if(this.state.file != ''){
      const formData = new FormData();
      formData.append('file', this.state.file)
      let urlUpload = '';
      if(this.props.user == "Partner"){
        urlUpload =  '/os/ossui/v1/ex/quotePartner/upload';
      } else{
        urlUpload =  '/os/ossui/v1/ex/customerLPO/upload';
      }
      await axios.post(urlUpload, formData, {
        params: {"legacyNo":this.props.legacyNo,"user":this.props.user},
        onUploadProgress: ProgressEvent => {
          this.setState({
            loaded: (ProgressEvent.loaded / ProgressEvent.total*100),
          })
        },
      }).then(res => {
        this.setState({textStyle:{"color":"#5cb85c","float":"left"}});
        alert('File Uploaded');
        document.getElementById("showFileName").innerHTML = "*"+this.state.file.name+" was uploaded successfully!!";
        this.setState({ file: ''});
        document.getElementById("fileInput").value='';
      })
       .catch(error => {
        this.setState({textStyle:{"color":"#c1401a","float":"left"}});
        alert('Upload Fail:'+error.response.data);
        document.getElementById("showFileName").innerHTML = "*"+this.state.file.name+" was not uploaded";
        this.setState({ file: '',loaded:0});
        document.getElementById("fileInput").value='';
       });
    } else {
      alert('Error: No File Selected');
    }
  }

  render() {

    return (
      <span>
      <input id="fileInput" type="file" onChange={this.onFileChange} />  <br/> <button style={{"float":"left"}} type="button" className="btn btn-primary" onClick={this.onSubmit}>Upload</button>
      <br/><br/>
      <Progress name="uploadProgress" value={this.state.loaded}/>
      <span style={this.state.textStyle} id="showFileName"></span>
      </span>
    );	
  }
}

//----------------------------------------------------------------------
//  Inner Modal For DMFI
//
//----------------------------------------------------------------------

class SimpleInnerModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };
    this.openSimpleInnerModal  = this.openSimpleInnerModal.bind(this);
    this.closeSimpleInnerModal = this.closeSimpleInnerModal.bind(this);
    this.handleAction          = this.handleAction.bind(this);
  }
 
  async handleAction(actionBtn,modalId) {
    var legacyOrderNo = this.props.order.legacy_order_no;
    var url = '';
    var resData = "";
    var rejReason = "";
    if(actionBtn == "RejectCust") {
      if(document.getElementById("rejReason")) {
        rejReason = document.getElementById("rejReason").value;
      }
      try {
        $(modalId).hide();
        url = '/os/ossui/v1/ex/updateOrderWorkflowQuoteCustRej/' + legacyOrderNo;
        const resp = await axios.post(url, { rejReason: rejReason });
        //console.log(resp.data.data[0].workflow_status);
        resData = resp.data.data[0].workflow_status;
        if(resData)      
          this.props.onGetData(resData);
        alert('Response submitted successfully!'); 
      } catch (err) {
        // Handle Error Here
        console.error(err);
        alert('Some error occured, Please try again.');
      }

    } else  if(actionBtn == "AcceptCust") {
      try {

        var urlCountryCheck = '/os/ossui/v1/ex/checkCountryForLPO/' + this.props.order.end_customer_country;
        const response = await axios.post(urlCountryCheck,{});

        //if the country is LPO mandatory, then check if the LPO is uploaded
        if (response.data.status == true) {
          var LPODocCheck = '/os/ossui/v1/ex/quotePartner/documentCount/' + legacyOrderNo;
          const docResponse = await axios.get(LPODocCheck,{});

          if (docResponse.data.docCust == "0" ) {
            toast.error("LPO upload mandatory for your country, please upload the same before accepting the quote", {
              position: "top-right",
              autoClose: 30000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            return;
          }
        }

        $(modalId).hide();
        url = '/os/ossui/v1/ex/updateOrderWorkflowQuoteCustApp/' + legacyOrderNo;       
        const resp = await axios.post(url,{});
        //console.log(resp.data.data[0].workflow_status);
        resData = resp.data.data[0].workflow_status;
        if(resData)      
          this.props.onGetData(resData);
        alert('Response submitted successfully!');
      } catch (err) {
        // Handle Error Here
        console.error(err);
        alert('Some error occured, Please try again.');
      }

    } else  if(actionBtn == "UpdatePartner") {
      try {
        $(modalId).hide();
        url = '/os/ossui/v1/ex/updateOrderWorkflowQuotePartnerProp/' + legacyOrderNo;       
        const resp = await axios.post(url,{});
        //console.log(resp.data.data[0].workflow_status);
        resData = resp.data.data[0].workflow_status;
        if(resData)      
          this.props.onGetData(resData);
        alert('Quote submitted successfully!');
      } catch (err) {
        // Handle Error Here
        console.error(err);
        alert('Some error occured, Please try again.');
      }

    } else  if(actionBtn == "RejectPartner") {
      try {
        $(modalId).hide();
        url = '/os/ossui/v1/ex/updateOrderWorkflowQuotePartnerRej/' + legacyOrderNo;       
        const resp = await axios.post(url,{});
        //console.log(resp.data.data[0].workflow_status);
        resData = resp.data.data[0].workflow_status;
        if(resData)      
          this.props.onGetData(resData);
        alert('Response submitted successfully!');
      } catch (err) {
        // Handle Error Here
        console.error(err);
        alert('Some error occured, Please try again.');
      }

    } else  if(actionBtn == "SubmitPartner") {
      var partnerPO = "";
      try {
        if(document.getElementById("PoNumber")) {
          partnerPO = document.getElementById("PoNumber").value;
        }

        if(partnerPO == "") {
          toast.error("Error: Partner PO is empty.", {
            position: "top-right",
            autoClose: 30000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          return;
        }

        if(partnerPO.length > 30) {
          toast.error("Error: Partner PO length exceeding max length(30).", {
            position: "top-right",
            autoClose: 30000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          return;
        }

        $(modalId).hide();
        this.setState({isLoading: !this.state.isLoading})
        this.props.action();

        url = '/os/ossui/v1/ex/updateOrderWorkflowPartnerPONo';
        const resp_return = await axios.post(url,{lno:legacyOrderNo,po:partnerPO});

        if (resp_return.data.status == "S") {

          url = '/os/ossui/v1/ex/updateOrderWorkflowQuotePartnerSub/' + legacyOrderNo;
          const resp = await axios.post(url,{});

          if (resp.data.status == "E" ) {
            if(resp.data.data == "Execution time limit exceeded" ) {
                toast.error("The action could not be completed. Please try again later !", {
                  position: "top-center",
                  autoClose: 30000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
            } else if (resp.data.data == "Order Locked" ) {
              toast.error("The action could not be completed as the order is being blocked for changes. Please try again later !", {
                position: "top-center",
                autoClose: 30000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            } else {
              toast.error("Some error occured, Please try again.", {
                position: "top-center",
                autoClose: 30000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }

          } else if (resp.data.status == "S" ) {

            resData = resp.data.data[0].workflow_status;
            if(resData) {
              this.props.onGetData(resData);
              toast.success("Order successfully released !", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          }
        } else {
          toast.error("Could not update Partner PO, Please try again later !", {
            position: "top-center",
            autoClose: 30000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } catch (err) {
        toast.error("Some error occured, Please try again.", {
          position: "top-center",
          autoClose: 30000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      this.setState({isLoading: !this.state.isLoading})
      this.props.action();

    } else  if(actionBtn == "PartnerDates") {
      var custDate = "", partnerNotes = "";
      if(document.getElementById("CustomerDate"))
        custDate = document.getElementById("CustomerDate").value;
      if(document.getElementById("textAreaNotes"))
        partnerNotes = document.getElementById("textAreaNotes").value;

      if(custDate == "" && partnerNotes == "") {
        alert('Error: Both Partner Notes and Date fields are empty');
      } else {
        try {
          $(modalId).hide();
          url = '/os/ossui/v1/ex/updateOrderWorkflowPartnerNotes';
          const resp = await axios.post(url,{lno:legacyOrderNo,pn:partnerNotes,edd:custDate});
          alert('Updated successfully!');
          //console.log(resp.data.data[0].workflow_status);
        } catch (err) {
          // Handle Error Here
          console.error(err);
          alert('Some error occured, Please try again.');
        }
      }
    }
    //console.log("RESP DATA " + resData);	  
    // this.props.onGetData(resData);	  
  }	  

  openSimpleInnerModal(modalId) {
    $(modalId).show();
  }

  closeSimpleInnerModal(modalId) {
    $(modalId).hide();
  }

  render() {

     var btnText = "";
     var header = "";
     var label = "";
     var actionBtn = "";   
     var modalId ="#"+this.props.modalId;
     var addFeature = "";
     var actionBtnStyle = {};
     var closeBtn = "No";
     var footerLabel = "";

     if(this.props.modalAction == "RejectPartner") {
       btnText   = "Reject Quote";
       header    = "Confirmation";
       label     = "Are you sure you want to reject this quote request ?";
       actionBtn = "Yes";
     } else if (this.props.modalAction == "AcceptCust") {
       btnText   = "Accept Quote";
       header    = "Confirmation";
       label     = "Are you sure you want to Accept this quote Update?";
       actionBtn = "Yes";
     } else if (this.props.modalAction == "RejectCust") {
       btnText   = "Reject Quote";
       header    = "Confirmation";
       label     = "Are you sure you want to reject this quote request?";
       actionBtn = "Yes";
       addFeature = <span style={{"float":"left"}}><input type="text" id="rejReason" placeholder="rejection reason" /><br/></span>;
     } else if (this.props.modalAction == "UpdatePartner") {
       btnText    = "Update Quote";
       header     = "Upload Quote Document";
       label      = "Please Upload your prices For the Customer:";
       actionBtn  = "Send to Customer";
       addFeature = <QuoteUpload legacyNo={this.props.order.legacy_order_no} user={"Partner"}/>;
     } else if (this.props.modalAction == "SubmitPartner") {
       btnText    = "Quote to Order";
       header     = "Confirmation";
       label      = "Please Provide Partner Purchase Order Number";
       actionBtn  = "Yes";
       addFeature = <span style={{"float":"left"}}><input type="text" id="PoNumber" placeholder="Partner PO number" /><br/></span>;
       footerLabel = "Are you sure you want to Submit this DMFI order to HP?";
     } else if (this.props.modalAction == "PartnerDates") {
       btnText    = "Update Dates";   
       header     = "Update Dates";
       label      = <center><span>Please update below the dates needed by the DMFI End Customer <br/> <br/>Actual Dates<br/><br/></span></center>;
       actionBtn  = "Save";
       addFeature = <span><span style={{"float":"left"}}><input type="date" id="CustomerDate" /><br/></span>&nbsp;&nbsp;<span style={{"float":"right"}}><textarea id="textAreaNotes" rows="10" cols="50" placeholder="Partner Notes For End Customer (500 Characters)"></textarea></span><br/><br/></span>;
     } else if (this.props.modalAction == "UploadLPO") {
       btnText    = <><i className="glyphicon glyphicon-circle-arrow-up"/>&nbsp;Upload LPO</>;
       header     = "Upload LPO Document";
       label      = "Please Upload LPO for the Partner:";
       addFeature = <QuoteUpload legacyNo={this.props.order.legacy_order_no} user={"Customer"} />;
       actionBtnStyle = {"display":"flex","justifyContent":"center","alignItems":"center"};
       closeBtn = "Close";
     }
    
	  
     return(
       <span>
         <a onClick={() => this.openSimpleInnerModal(modalId)}  className={this.props.classNm} disabled={this.state.isLoading} >{btnText}</a>
         <div className="modal" id={this.props.modalId} data-backdrop="static" style={{"overflow":"hidden"}}>
           <div className="modal-dialog">
             <div className="modal-content">
               <div className="modal-header">
                 <span style={{"textAlign":"left"}}><h4 className="modal-title">{header}</h4></span>
               </div>
               <div className="container">
               </div>
               <div className="modal-body">
                 <br/>
                 <span>   
                   <h6 style={{"textAlign":"left"}}>{label}</h6>
                   {addFeature}
                   <br/>
                   <br/>
                   <h6 style={{"textAlign":"left"}}>{footerLabel}</h6>
                 </span> 
               </div>
               <div id="modalFooter" className="modal-footer" style={actionBtnStyle}>
                 {this.props.modalAction != "UploadLPO" && <a href="#" onClick={() => this.handleAction(this.props.modalAction,"#"+this.props.modalId) }className="btn btn-success" style={{"float":"left","color":"white"}}>{actionBtn}</a>}
                 <a href="#" onClick={() => this.closeSimpleInnerModal("#"+this.props.modalId)} className="btn btn-danger" style={{"float":"left","color":"white"}}>{closeBtn}</a>
               </div>
             </div>
           </div>
         </div>
       </span>
    );
  }
};

//----------------------------------------------------------------------
//   OSWidget -- the widget with the modal wrapper
//
//----------------------------------------------------------------------
export class OSWidget extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      workflowStatus        : this.props.order.workflow_status,
      docCountPart          : 0,
      docCountCust          : 0,
      dataDict              : [],
      actionProgress        : false,
      crpItems: []
    };


    this.getDocCount     = this.getDocCount.bind(this);
    this.handleSubsClick = this.handleSubsClick.bind(this);
    this.handleChildData = this.handleChildData.bind(this);
    this.reloadDMFIGrid  = this.reloadDMFIGrid.bind(this);
    this.handleActionProgress = this.handleActionProgress.bind(this);
    this.updateCRPItems = this.updateCRPItems.bind(this);
  }


  async getDocCount() {
    var url = '/os/ossui/v1/ex/quotePartner/documentCount/'+this.props.order.legacy_order_no;
    var sanitizeURL = sanitizeUrl(url);
    var result = await axios.get(sanitizeURL, {});
    this.setState({docCountPart:result.data.docPart,docCountCust:result.data.docCust});
  }

  handleSubsClick = () => {
    var self = this;
    self.props.handleExtSubs(true);
  }

  handleChildData = (workflowSt) => {
   this.setState({workflowStatus: workflowSt});
   //console.log("Value from child " + workflowSt);   
  }

  reloadDMFIGrid = () => {
    $("a[href='#dmfiPendingTab']").attr('id', 'dmfiPendingTab');
    if (document.getElementById('dmfiPendingTab')) {
      document.getElementById('dmfiPendingTab').click();
    }
  }

  handleActionProgress() {
    this.setState({actionProgress: !this.state.actionProgress});
  }

  updateCRPItems(crpItemsNew) {
    this.setState({crpItems: [...crpItemsNew]});
  }

  componentDidMount() {

      var properties = ['name', 'short_desc', 'db_field', 'ext_widget_field', 'new_ext_rep_field', 'old_ext_rep_field']
      DataDict.custom('ext_widget', properties, function(dataDict) {
        this.setState({ dataDict: dataDict });
      }.bind(this), DDErrorHandler);

      $(document).on('click', '.dropdown-menu .dropInfoWin', function (e) {
        //console.log('.dropdown-menu dropInfoWin e.stopPropagation');
        e.stopPropagation();
      });
      if (this.props.order.trade_model == "DMFi")
        this.getDocCount();
  }

  render() {

    var width = "995px";
    if (this.props.width) {
      width = this.props.width;
    }

    var myWidgetMode = "external";
    if (this.props.myWidgetMode) {
      myWidgetMode = this.props.myWidgetMode;
    }

    var order = this.props.order;
    var item_subitem = this.props.item_subitem;

    if (window.UserSettings && Object.keys(UserSettings).length == 0) {
      //console.log("overwrite UserSettings from window value")
      UserSettings = window.UserSettings;
    }

    if ( order.length > 1 ) {
      console.log( 'Multiple orders matching filter criteria...' );
      return (
        <ModalWithClose id="ossOrderModal" handleClose={handleCloseModal} closeButtonText={T('Close')} width={width}>

          <ModalTitle handleClose={handleCloseModal}>
            <L>Multiple orders found</L>
            &nbsp;-&nbsp;
            <L>Please select</L>:
          </ModalTitle>

          <ModalBody>
            <OrderSelectList order={order} b2bparameters={this.props.b2bparameters}/>
          </ModalBody>

        </ModalWithClose>
      )

    } else {
      var goBack = null;
      var hideClose = false;

      if (window.extMobileMode) {
        var reducedTopPadding = ".modal-body { padding: 4px 3px 6px 3px;}";
      } else {
        var reducedTopPadding = ".modal-body { padding: 15px 15px 15px 15px;}";
      }

      if (this.props.withoutModal) {
        goBack = <button onClick={() => this.props.history.goBack()} className="bar-page-options-go-back"></button>
        hideClose = true;
      }

      var titleLabel = "";
      var dmfiLabel = "";
      var extSubsIcon = "";

      if ( this.props.tenant != "HPICS" || order.sn_no == '' ) {
        if ( order.purchase_order_no != '' ) {
          titleLabel = window.extMobileMode ? <span>{T('PO: ')} <span className="heading-weight">{ order.purchase_order_no}</span></span> : <span>{T('Purchase Order: ')} <span className="heading-weight">{ order.purchase_order_no}</span></span>;
        }
      } else {
        titleLabel   = window.extMobileMode ? <span>{T('SN No: ')}  <span className="heading-weight">{order.sn_no}</span></span> : <span>{T('Service Notification No: ')}  <span className="heading-weight">{order.sn_no}</span></span>;
      }

      if (["DMFi", "Multichannel DMFi", "Multichannel STM"].includes(this.props.order.trade_model) && this.props.order.partner_purch_order_no != "") {
        dmfiLabel =  <span>{T('Partner Purchase Order: ')}  <span className="heading-weight">{this.props.order.partner_purch_order_no}</span></span>;
      }

      if (this.props.extSubs && this.props.extSubs.mode == 'watched') {
        if (this.props.extSubs.action == 'Y') {
          extSubsIcon = window.extMobileMode ?  <span onClick={this.handleSubsClick} style={{'marginLeft': '10px', 'color': '#BBBBBB'}}><SubscribeIcon /></span> : null ;
        } else {
          extSubsIcon = window.extMobileMode ?  <span style={{'marginLeft': '10px', 'color': '#00AA00'}}><SubscribeIcon /></span> : null ;
        }
      }

      var showPartnerFirst = false;
      var showPartnerSec   = false;
      var showPartnerThird = false;
      var showCustomer     = false;

      if (order.trade_model == "DMFi" && UserSettings["isPartner"] !== undefined) { 
        if (UserSettings.isPartner) {

          if(order.originating_system != "HP2B CSR") {
            switch (this.state.workflowStatus) {
              case "quote_cust_req"   :  case "quote_cust_rej" : showPartnerFirst = true;   break;
              case "quote_cust_app"   :  showPartnerSec   = true;   break;
              case "quote_partner_sub":  showPartnerThird = true;   break;
            }
          } else{
            if(this.state.workflowStatus != "quote_partner_sub")
              showPartnerSec   = true;
            else
              showPartnerThird = true;
          }
        } else {
          if (  this.state.workflowStatus != 'quote_cust_rej'
             && this.state.workflowStatus != 'quote_cust_app'
             && this.state.workflowStatus == 'quote_partner_prop'
          ) {
            showCustomer = true;
          }
        }
      }
      
      var showQuoteDownload     = false;
      var showQuoteDownloadCust = false;

      if(order.trade_model == "DMFi" && this.state.workflowStatus != 'quote_cust_req' && this.state.docCountPart > 0){
        showQuoteDownload = true;
      }

      if(order.trade_model == "DMFi" && (this.state.workflowStatus != 'quote_cust_req') && this.state.docCountCust > 0){
        showQuoteDownloadCust = true;
      }

      var exportExtButton = null; 
      if (typeof WidgetMode == 'undefined' || WidgetMode != 'onetime') {
        if (myWidgetMode != 'public') {
          exportExtButton = <ExportExtExcelOrder size="md" inverted={true} order={order} b2bparameters={this.props.b2bparameters} sfdcSignedRequest={this.props.sfdcSignedRequest} />
        }
      }

      var submitRequestBtn = null;
      if (myWidgetMode != 'public' && !OSWidgetLib.ZMSOOrder(this.props.order)) {
          submitRequestBtn = <InitSFDCWorkflow order={order} locale={I18N.locale} isExternalWidget={true} crpItems={this.state.crpItems} />;
      }


      let handleClose = order.trade_model == "DMFi" ? this.reloadDMFIGrid : handleCloseModal;


      var wTitle =
        <ModalTitle handleClose={handleClose} hideClose={hideClose}>
          <span style={{"fontSize": "12px", "color": "#777777", "float": "right", "textAlign": "right", "marginTop": "5px", "marginRight": "15px"}}>
            <strong>Last Order Update:</strong> {fmDateTime(this.props.order.last_update)}
            {exportExtButton}
          </span>
          {goBack}
          {this.props.order.order_type_descr}: <span className="heading-weight">{order.order_no}</span>
          &nbsp;&nbsp;&nbsp;&nbsp;
          {titleLabel} {order.trade_model == 'DMFi' ? <br/> : ''}
          {dmfiLabel}
          {extSubsIcon}
        </ModalTitle>


      var wBody =
        <ModalBody>
          <DetailedOrderStatus myWidgetMode={myWidgetMode} order={order} userSettings={UserSettings} sfdcSignedRequest={this.props.sfdcSignedRequest} b2bparameters={this.props.b2bparameters} item_subitem={item_subitem} updateCRPItems={this.updateCRPItems} crpItems={this.state.crpItems}/>
        </ModalBody>


      if (window.extMobileMode) {
        var wFooter =
          <ModalFooter>
            <div>
              <div style={{"display":"inline", "float": "left"}}>
                {exportExtButton}
                &nbsp;
                {submitRequestBtn}
              </div>
            </div>
          </ModalFooter>
      } else {
        var wFooter =         
          <ModalFooter>
            <div>
              <div style={{"display":"inline", "float": "right"}}>
                <table><tr><td>
                  {showPartnerFirst  && <SimpleInnerModal  order={order}  classNm={"btn btn-success btn-smallest"}  modalAction={"UpdatePartner"}     modalId={"myModal2"} onGetData={this.handleChildData} /> }
                  {showPartnerFirst  && <SimpleInnerModal  order={order}  classNm={"btn btn-danger  btn-smallest"}  modalAction={"RejectPartner"}     modalId={"myModal3"} onGetData={this.handleChildData} /> }
                  {showCustomer      && <SimpleInnerModal  order={order}  classNm={"btn btn-success btn-smallest"}  modalAction={"AcceptCust"   }     modalId={"myModal4"} onGetData={this.handleChildData} /> }
                  {showCustomer      && <SimpleInnerModal  order={order}  classNm={"btn btn-danger  btn-smallest"}  modalAction={"RejectCust"   }     modalId={"myModal5"} onGetData={this.handleChildData} /> }
                  {showCustomer      && <SimpleInnerModal  order={order}  classNm={"btn btn-success btn-smallest"}  modalAction={"UploadLPO"}         modalId={"myModal9"} /> }
                  {showPartnerSec    && <SimpleInnerModal  order={order}  classNm={"btn btn-primary btn-smallest"}  modalAction={"SubmitPartner"}     modalId={"myModal6"} onGetData={this.handleChildData} action={this.handleActionProgress}/> }
                  {showPartnerThird  && <SimpleInnerModal  order={order}  classNm={"btn btn-primary btn-smallest"}  modalAction={"PartnerDates" }     modalId={"myModal8"} /> }
                  {showQuoteDownload     && <QuoteDownload  legacyNo={order.legacy_order_no} user={"Partner"} />}
                  {showQuoteDownloadCust && <QuoteDownload  legacyNo={order.legacy_order_no} user={"Customer"} />} &nbsp; &nbsp;
                  {order.trade_model == "DMFi" && <span style={{"background":"#0096d6","padding":"1px 8px 1px 9px","color":"white","borderRadius":"5px", "verticalAlign":"text-bottom"}} title={T(order.workflow_status)}>i</span>} &nbsp; &nbsp;
                </td><td style={{"display":"inline" }} >{ this.state.actionProgress ? <Loading size='XS' /> : null }</td></tr></table>
              </div>
            </div>
          </ModalFooter>
      }

      if (this.props.withoutModal) {
        return (
          <div id="ossOrderFlat" width={width} >
            {wTitle}
            <style>{reducedTopPadding}</style>
            {wBody}
            {window.extMobileMode || order.trade_model === "DMFi" ? wFooter : null}
          </div>
        )
      } else {
        return (
          <Modal id="ossOrderModal" width={width} >
            {wTitle}
            <style>{reducedTopPadding}</style>
            {wBody}
            {window.extMobileMode || order.trade_model === "DMFi" ? wFooter : null}
          </Modal>
        );
      }
    };
  }
};


// GEGA: Merge this function (which is used twice) to components with simplify project
class MFGListPopUp extends React.Component {

  render() {

    var headerRow =
              <tr>
                  <th><L>Item</L></th>
                  <th><L>Product</L></th>
                  <th><L>Shipment</L></th>
                  <th><L>Serial Number</L></th>
                  <th><L>Asset Tag</L></th>
                  <th><L>Primary Mac Address</L></th>
              </tr>;

    var param = '';
    if (this.props.b2bparameters && this.props.b2bparameters != "") {                                   
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }
    var data_source = this.props.data_source;
    var lineDetails = this.props.mfgList.map( function(row,i) {

        return (
          <tr><td>{row.so_item_no}</td><td>{row.material_no}</td><td>{row.shipment_no}</td><td>{row.serial_number}</td><td>{row.asset_tag}</td><td>{row.primary_mac_addr}</td>
          </tr>
          )
    });

    return(
      <div style={{"overflow":"auto","height":"330px"}}>
        <table className="table table-hover table-inv">
          <thead>
           {headerRow}
          </thead>
          <tbody>
            {lineDetails}
          </tbody>
        </table>
      </div>
    );
  }
};


export class InvoiceListPopUp extends React.Component {

  //GEGA TODO, CHANGE LINKS AND ALSO SEE WHY THE RED DLL BUTTON IS MISSIN ??!
  constructor(props) {
    super(props);
    this.handleDownloadAll = this.handleDownloadAll.bind(this);
  }

  handleDownloadAll() {

    var param = '';
    var prefix = '';

    if (this.props.b2bparameters) {
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }

    window.open (RewriteRESTURL(prefix + "invoiceStatusExt.html?legacy_order_no="+this.props.legacy_order_no+"&language="+I18N.locale+"&type=ex&order_no="+this.props.order_no+param),"downloadwindow","menubar=1,resizable=1,width=450,height=450");

  }

  render() {

    var invoiceStatus = "";
    var downloadAllInvoice = "";

    if(this.props.invoiceStatus == "PI") {

      invoiceStatus = "(Partially Invoiced)"
    }

    if(this.props.invoiceStatus == "FI") {

      downloadAllInvoice = "Download All Invoices"
    }
    //console.log(this.props.invoiceList);

    var patt = new RegExp("SAP-FAP2");
    var patt1 = new RegExp("SAP-AP");
    var patt2 = new RegExp("QAD-.*");
    var prepaymentUnique = [];
    var advanceInvoice = "";
    var preInvoice = "";

    var headerRow =
              <tr>
                  <th><L>Invoice No</L></th>
                  <th style={{"textAlign": "right"}}><L>Invoice Date</L></th>
                  <th style={{"textAlign": "right"}}><L>Invoice Amount</L></th>
                  <th><L>Download Document</L></th>
              </tr>;

    if (patt.test(this.props.data_source) || patt1.test(this.props.data_source) || patt2.test(this.props.data_source)) {
      headerRow = <tr>
                  <th><L>Invoice No</L></th>
                  <th style={{"textAlign": "right"}}><L>Invoice Date</L></th>
                  <th style={{"textAlign": "right"}}><L>Invoice Amount</L></th>
              </tr>;
    }

    var param = '';
    if (this.props.b2bparameters && this.props.b2bparameters != "") {                                   
      param = '&b2bparameters=' + encodeURIComponent( this.props.b2bparameters );
    }
    var data_source = this.props.data_source;
    var self = this;
    var invoices = this.props.invoiceList.map( function(row,i) {

      var url = RewriteRESTURL("/os/ossui/v1/ex/invoice?legacy_order_no="+row.legacy_order_no+"&invoice_no="+row.invoice_no+"&data_source="+row.data_source+param);

      if (sfdcSession) {
        url = "/os/" + url;
        url += "&sfdcSession=" + sfdcSession;
      }

      // CR 15559 - deactivate invoice link for QAD
      if ( row.system == "QAD-IL" || row.system == "QAD-JP" || row.system == "QAD-NL" ||  row.system == "QAD-US" ) {
        url = '';
      }

      // CR 17221  forbid inv download for end customer for DMFI orders
      if (self.props.forbidInvDownload && self.props.forbidInvDownload == 'Y') {
        url = '';
      }   

      if (row.pre_payment_advance_invoice && !prepaymentUnique.includes(row.prepayment_advance_inv)) {
        if (row.advance_invoice_date != "") {
          preInvoice = <tr><td>{row.pre_payment_advance_invoice + " - PrePayment Invoice"}</td><td style={{"textAlign": "right"}}>{fmDate(row.pre_payment_invoice_date)}</td><td style={{"textAlign": "right"}}>{''} &nbsp; &nbsp; {''}</td> 
          <td><a href={url} target="_blank"> <img height="32" src={Bill_RGB_green_NT}/></a></td></tr>
          advanceInvoice = <tr><td>{row.pre_payment_advance_invoice + " - Advance Invoice"}</td><td style={{"textAlign": "right"}}>{fmDate(row.advance_invoice_date)}</td><td style={{"textAlign": "right"}}>{''} &nbsp; &nbsp; {''}</td> 
          <td><a href={url} target="_blank"> <img height="32" src={Bill_RGB_green_NT}/></a></td></tr>
        } else {
          preInvoice = <tr><td>{row.pre_payment_advance_invoice + " - PrePayment Invoice"}</td><td style={{"textAlign": "right"}}>{fmDate(row.pre_payment_invoice_date)}</td><td style={{"textAlign": "right"}}>{''} &nbsp; &nbsp; {''}</td> 
          <td><a href={url} target="_blank"> <img height="32" src={Bill_RGB_green_NT}/></a></td></tr>
        }
      }

      var hideDownload    = false;
      var replaceDownload = false;
      var amountText = '';
      if (row.net_price == null) {
          amountText = T('notAuthorized');
          hideDownload = true;
      } else
      if (self.props.forbidInvDownload && self.props.forbidInvDownload == 'Y') {
          var replaceText = T('');
          replaceDownload = true;
      } else
      if (row.data_source.indexOf("3RD-ERP") > -1) {
          var replaceText = T('Please contact your distributor to retrieve this invoice');
          replaceDownload = true;
      } else {
         var net_price = row.net_price;
         amountText = <span>{fmNum(net_price)} &nbsp; &nbsp; {row.currency}</span>
      }

      if (hideDownload || patt.test(data_source) || patt1.test(data_source) || patt2.test(data_source)) {
        return (
          <tr><td>{row.invoice_no}</td><td style={{"textAlign": "right"}}>{fmDate(row.invo_actual)}</td><td style={{"textAlign": "right"}}>{amountText}</td>
          </tr>
          )
      } else {
        if (replaceDownload) {
          var downloadCol = replaceText;
        } else {
          var downloadCol = <a href={url} target="_blank"> <img height="32" src={Bill_RGB_green_NT}/></a>;
        }
        return (
          <tr><td>{row.invoice_no}</td><td style={{"textAlign": "right"}}>{fmDate(row.invo_actual)}</td><td style={{"textAlign": "right"}}>{fmNum(net_price)} &nbsp; &nbsp; {row.currency}</td>
          <td>{downloadCol}</td></tr>
          )
      }
    });

    if (this.props.modalView == "invoices") {
      var reducedTopPadding = ".modal-body { padding: 5px 15px 15px 15px;}";
      return(
        <ModalWithClose id="ossInvoiceModal" handleClose={handleCloseModal} closeButtonText={T('Close')} width="620px" >
          <ModalTitle hideClose={true}>
            <InvoicePopupWrapperClass
              handleDownloadAllInvs={this.handleDownloadAll}
              hideDownloadAllInvs={this.props.hideDownloadAllInvs}
              order={
                {
                  legacy_order_no : this.props.legacy_order_no,
                  order_no        : this.props.order_no,
                  data_source     : this.props.data_source
                }
              }/>
          </ModalTitle>
          <style>{reducedTopPadding}</style>
          <ModalBody>
            <div style={{"overflow":"auto","height":"330px"}}>
              <table className="table table-hover table-inv">
                <thead>
                {headerRow}
                </thead>
                <tbody>
                  {preInvoice}
                  {advanceInvoice}
                  {invoices}
                </tbody>
              </table>
            </div>
          </ModalBody>

        </ModalWithClose>      
      )
    } else {
      return(
        <div style={{"overflow":"auto","height":"330px"}}>
          <table className="table table-hover table-inv">
            <thead>
             {headerRow}
            </thead>
            <tbody>
              {preInvoice}
              {advanceInvoice}
              {invoices}
            </tbody>
          </table>
        </div>
      );
    }
  }
};


class ShipmentPopupWrapperClass extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var exportXLURL = RewriteRESTURL("/os/ossui/v1/ex/exportShipmentDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale);

    if (this.props.b2bparameters && this.props.b2bparameters != "") {
      exportXLURL = "/os/ossui/v1/ex/exportShipmentDataToExcel/" + this.props.order.legacy_order_no + "/" + this.props.order.order_no + "/" + I18N.locale + "?b2bparameters=" + encodeURIComponent(this.props.b2bparameters);
    }

    var massDLClass = "btn btn-danger";
    if (this.props.disableButtons) {
      massDLClass = "btn btn-danger disabled";
    }

    // Show "for Order..." text only in external modal view
    var orderText = null;
    if (this.props.showOrderText !== false) {
      orderText = <div className="pull-left">{T('for') + " " + T('Order') + " " + this.props.order.order_no}</div>;
    }

    return (
      <h4 key="ShipmentPopupWrapperClass" className="modal-title" style={{ "textAlign": "left"}}>
        <div className="pull-left">{T('Shipment(s)')}</div>
        {orderText}
        <div id="downloadShipData" className="pull-right">
          <a className={massDLClass} style={{ "padding": "1px 10px" }} onClick={this.props.handleMassDL} title="mass download POD Docs" name="pod-docs">{T('All PODs')}</a>
          &nbsp;
          <a href={exportXLURL} target="_blank" title={T('DownloadShipmentDataToolTip')} className="btn btn-danger" style={{ "color": "white", "padding": "1px 10px" }}>{T('Shipment Details')}</a>
          &nbsp;
          <a className={massDLClass} style={{ "padding": "1px 10px" }} onClick={this.props.handleMassDL} title="mass download Packing Lists" name="packing-list">{T('All Packing Lists')}</a>
        </div>
      </h4>
    );
  }
};


export class ShipmentListPopUp extends React.Component {

  constructor(props) {
    super(props);
    this.handlePodImage = this.handlePodImage.bind(this);
    this.handleMassDL = this.handleMassDL.bind(this);
  }

  handlePodImage(legacyorderno, shipmentno, carriername, trackingno, hpdeliveryno, TATPreURL) {
    var param = '';
    if (this.props.b2bparameters && this.props.b2bparameters != "") {
      param = '&b2bparameters=' + encodeURIComponent(this.props.b2bparameters);
    }
    var podUrl = "/os/podimg?shipment=" + shipmentno + "&lno=" + legacyorderno + "&ex=Y" + param;
    window.open(podUrl, "downloadwindow", "menubar=1,resizable=1,width=750,height=590");
    event.preventDefault();
  }

  handleMassDL = e => {
    e.preventDefault();

    var order_no = this.props.order_no;
    var shipmentList = this.props.shipmentList || [];
    var uniqueMassDLNos = [];

    // Extract unique shipment numbers from shipmentList
    for (var i = 0; i < shipmentList.length; i++) {
      if (shipmentList[i].shipmentno && shipmentList[i].shipmentno != "") {
        if (uniqueMassDLNos.indexOf(shipmentList[i].shipmentno) === -1) {
          uniqueMassDLNos.push(shipmentList[i].shipmentno);
        }
      }
    }

    axios.post('/os/ossui/v1/ex/massDL/createSerialReport', {
      id: "",
      name: "OSWidget_" + order_no,
      description: "",
      type: e.target.name,
      values: {
        file: "n/a",
        method: "paste",
        values: uniqueMassDLNos
      }
    })
    .then(response => {
      var message = response.data.name + " submitted for processing";
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    })
    .catch(error => {
      toast.error(error.response.statusText, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
  };

  render() {
    if (this.props.modalView == "shipments") {
      return (
        <ModalWithClose id="ossShipmentModal" handleClose={handleCloseModal} closeButtonText={T('Close')} width="920px">
          <ModalTitle hideClose={true}>
            <ShipmentPopupWrapperClass
              handleMassDL={this.handleMassDL}
              b2bparameters={this.props.b2bparameters}
              order={
                {
                  legacy_order_no : this.props.legacy_order_no,
                  order_no        : this.props.order_no
                }
              }/>
          </ModalTitle>
          <ModalBody>
            <ToastContainer />
            <div id="shipmentResultMsg"></div>
            <div style={{ "margin": "7px", "maxHeight": "500px", "overflow": "auto" }}>
              <ShipmentListWidget
                callerArea={this.props.callerArea}
                shipmentList={this.props.shipmentList}
                OMSystem={this.props.OMSystem}
                handlePodImage={this.handlePodImage}
                TATPreURL={this.props.TATPreURL}
                orderAAID={this.props.orderAAID} />
            </div>
          </ModalBody>
        </ModalWithClose>
      )
    } else {
      return (
        <ShipmentListWidget
          callerArea={this.props.callerArea}
          shipmentList={this.props.shipmentList}
          OMSystem={this.props.OMSystem}
          handlePodImage={this.props.handlePodImage}
          TATPreURL={this.props.TATPreURL}
          orderAAID={this.props.orderAAID} />
      );
    }
  }
};


function ShpTypeIcon ( shipping_type )
{
   if (shipping_type.toLowerCase() == "train"   ) return <img src={train_icon}/>;
   if (shipping_type.toLowerCase() == "rail"    ) return <img src={train_icon}/>;
   if (shipping_type.toLowerCase() == "airplane") return <img src={airplane}/>;
   if (shipping_type.toLowerCase() == "air")      return <img src={airplane}/>;
   if (shipping_type.toLowerCase() == "vessel"  ) return <img src={vessel}/>;
   if (shipping_type.toLowerCase() == "sea"     ) return <img src={vessel}/>;
   if (shipping_type.toLowerCase() == "ocean"   ) return <img src={vessel}/>;
   if (shipping_type.toLowerCase() == "ship/air") return <img src={vessel}/>;
   if (shipping_type.toLowerCase() == "a0"      ) return <img src={airplane}/>;
   if (shipping_type.toLowerCase() == "a1"      ) return <img src={airplane}/>;
   if (shipping_type.toLowerCase() == "m"       ) return <img src={Shipping_RGB_blue_NT} height="16"/>;
   // M->Truck mapping after discussion with Titus and Oliver, this is for seen for VISTA orders
   return  <img height="16" src={Shipping_RGB_blue_NT} />
}


//GEGA TODO DELETE OR CONSOLIDATE
class SchedLines extends React.Component {

  constructor(props) {
    super(props);
  }

  handleClick(legacy_order_no) {

      var Params = {
          lookupType: "legacy_order_no",
          lookupValue: legacy_order_no,
          callingSystem: 'quicksearch'
      }
      GET("/os/ossui/v1/ex/widget/order", Params,function(resp) {

          if (resp.status == 'N') {
            alert(resp.message);
          } else {

            ReactDOM.render(
              <OSWidgetInt
                order={resp.data}
                quickSearchResp={resp.data}/>
              , document.getElementById('internalWidget')
            );

            $('#ossOrderModal').modal({backdrop: 'static' });
          }
      });
  }

  render() {

    var order = this.props.data;
    var orderDetails =
      <tr>
        <td><a onClick={this.handleClick.bind(null,order.legacy_order_no)} style={{ "cursor": "pointer" }}>{order.order_no}</a></td>
        <td>{fmDate(order.purch_order_date)}</td>
        <td>{order.purchase_order_no}</td>
        <td>{order.order_type}</td>
        <td>{order.customer_name}</td>
        <td>{order.order_overall_status}</td>
        <td>{order.schedLines.length > 0 ? order.schedLines[0].shipment_no : null}</td>
        <td>{order.schedLines.length > 0 ? order.schedLines[0].invoice_no  : null}</td>
      </tr>

    var scheduleLines = this.props.data.schedLines.map(function(sched_Line,i) {

        if(i>0) {
          return (
            <tr>
             <td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td>
             <td>&nbsp;</td><td>&nbsp;</td>
             <td>{sched_Line.shipment_no}</td>
             <td>{sched_Line.invoice_no}</td>
            </tr>
          );
        }
    });
    return <div>{orderDetails} {scheduleLines} </div>;
  }
};
